import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import {
  Button,
  message,
  Spin,
  Modal,
  Input,
  Form,
  Typography,
  Dropdown,
  Flex,
  Tooltip,
  Upload,
  Switch,
  Space,
  Select,
  Tabs,
  Drawer,
  Popconfirm,
  Popover,
  FloatButton,
  Tag,
} from "antd";
import { v4 as uuidv4 } from "uuid";
import "dayjs/locale/zh-cn";
import { useBrowserClient } from "@sui/runtime";

import {
  ChatActionButton,
  ChatBox,
  ChatBoxItem,
  ChatBubblePrompts,
  ChatFeedBack,
  ChatInternetActionButton,
  ChatLayout,
  ChatLoadingDots,
  ChatPortalActionButton,
  ChatPromptsCard,
  ChatScrollWrapper,
  ChatSiteActionButton,
  ChatWelcome,
  useWebSocketClient,
  categories,
  ChatContext,
  ChatPortalLayout,
  ChatAgentCube,
  ChatTabsCard,
  ChatBubblePromptsCard,
  ChatThinkActionButton,
} from "@sui/chat-ui";
import {
  API,
  getcategaryList,
  getDeleteChat,
  getEvaluateData,
  getInitData,
  getNewChat,
  getSessionHistory,
  getSessionList,
  getUpdateChat,
  getZntHistory,
  getSkillList,
  getSelectedZnt,
  getTokenConsumption,
  getAudio2Text,
} from "@/api/index";
import { useMsgStore } from "@/hooks/useStore";
import useBaseRequest from "@/hooks/useBaseRequest";
import Search from "../../components/search";
import { IChatMenuItem } from "@sui/chat-ui/lib/ChatUI/components/ChatMenu";
import { getChatUrl, getUrlParam } from "@/utils/public";
import { useNavigate } from "react-router-dom";
import { BgCmdMessage } from "@/utils/message";
import {
  CloseOutlined,
  CloudUploadOutlined,
  DownOutlined,
  LoadingOutlined,
  ReloadOutlined,
  SwapRightOutlined,
  UserOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import { useArraySlicer } from "@/hooks";
import HeaderRightRender from "../HeaderRightRender";
import { parseContent, parseExtra, parseSource, parseSrcs } from "./utils";
import HelpDescription from "../helpDescription";
import RecordRTC from "recordrtc";
import Fj from "../../assets/images/fj.svg";
import DisFj from "../../assets/images/disfj.svg";

import SuccessPic from "../../assets/images/success.svg";
import HandlingPic from "../../assets/images/handling.svg";
import DclPic from "../../assets/images/dcl.svg";
import ErrorPic from "../../assets/images/error.svg";
import Logoff from "../../assets/images/logoff.svg";
import DefultIcon from "../../assets/images/defultIcon.png";
import nllogo from "../../assets/images/nllogo.png";
import LoginIcon from "../../assets/images/icon.png";
import Mrtx from "../../assets/images/mrtx.png";
import AudioIcon from "../../assets/images/audioIcon.svg";
import AudioLoadingIcon from "../../assets/images/audioLoadingIcon.svg";
import { Attachments, Prompts } from "@ant-design/x";
import axios from "axios";

import "./ChatUI.less";
import Zskzx from "../../components/zskzx";
import Mxgc from "../../components/mxgc";
import Mxgl from "../../components/mxgl";
import Cjzx from "../../components/cjzx";
import Slfw from "../../components/slfw";
import Zntkfpt from "../../components/zntkfpt";
import ZdSearch from "../../components/zdSearch";
import * as dd from "dingtalk-jsapi";
import ZdKnowledge from "./zsk";

categories.map((item) => {
  if (item.key === "brain") {
    item.text = window.zntTitle ? window.zntTitle : "智能体";
    // item.text = <Tooltip title={window.zntTitle ? window.zntTitle : "智能体"} >{window.zntTitle ? window.zntTitle : "智能体"}</Tooltip>
    item.title = "";
  }

  if (item.key === "chat") {
    item.text = window.chatTitle ? window.chatTitle : "对话";
    item.title = "";
    if (window.zdChatIcon) {
      item.icon = window.zdChatIcon;
    }
  }

  if (item.key === "search") {
    item.text = window.zdSeachTitle ? window.zdSeachTitle : "搜索";
    // item.text = <Tooltip title={window.zntTitle ? window.zntTitle : "智能体"} >{window.zntTitle ? window.zntTitle : "智能体"}</Tooltip>
    item.title = "";
  }
  // if (item.key === "search") {
  //     item.title = ""
  // }
});

// //将ws响应json解析成对象
const parseResponse = (response) => {
  if (response) {
    return JSON.parse(response)?.data?.[0];
  }
  return null;
};
const isMd = (msg) => {
  if (!msg?.form && msg?.answer && msg?.answer !== "" && msg?.isAI) {
    return true;
  }
  return false;
};

const isIframe = (msg) => {
  if (msg && msg?.form && msg?.form?.type === "link") {
    return true;
  }
  return false;
};

export default function ChatUI(props) {
  const {
    embed,
    single,
    embedOptions,
    portalLayout,
    defaultChatMode = "welecome",
    fixedName,
    chatBoxProps,
    ...others
  } = props;
  const { mode: newMode } = props;
  console.log(props, getUrlParam("skillName"), "合并之后的props");
  const [_mode, setMode] = useState(defaultChatMode);
  const mode = useMemo(() => {
    // 嵌入的，默认不开启welcome
    return embed && !embedOptions?.showDefaultWelcome ? "conversation" : _mode;
  }, [_mode, embed, embedOptions?.showDefaultWelcome]);
  const navigate = useNavigate();
  const manualStoppedMsgIds = useMsgStore((state) => state.manualStoppedMsgIds);
  const [activeMenu, setActiveMenu] = useState("chat");
  const [historyKey, setHistoryKey] = useState(getUrlParam("chatId") ?? "");
  const [renameData, setRenameData] = useState();
  const [renameOpen, setReNameOpen] = useState(false);
  const [agentName, setAgentName] = useState();
  const [renameForm] = Form.useForm();
  const SessionCache = useRef();
  const [items, setItems] = useState([]);
  const [znwdId, setZnwtId] = useState(getUrlParam("znwdId") ?? "");
  const [deleteKey, setDeleteKey] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const lastItemRef = useRef(null);
  const [refreshNew, setRefreshNew] = useState(""); // 用于刷新状态
  const initDataRef = useRef();
  const { data: hisData } = useBaseRequest(getZntHistory, {
    manual: true,
    onSuccess(res) {},
  });
  const [zskData, setZskData] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    key: "all",
    label: "全部知识库",
  });
  const [skillList, setSkillList] = useState([]);
  const [moreModel, setMoreModel] = useState([]);
  const [selectedModelValue, setSelectedModelValue] = useState({});
  const [newRefresh, setNewRefresh] = useState("");
  const [tabs, setTabs] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [alllength, setAllLength] = useState(0);
  const [historySearchId, setHistorySearchId] = useState("all");
  const [refreshHistory, setRefreshHistory] = useState("");
  const [skillsName, setSkillName] = useState("");
  const [skillId, setSkillId] = useState("");
  const [zdKnowledgeOpen, setZdKnowledgeOpen] = useState(false);
  const [zdKnowledgeName, setZdKnowledgeName] = useState("");
  const zdKnowledgeRef = useRef();
  const [zdzxJump, setZdzxJump] = useState(false);

  /**
   * 切换智能体
   * @param id
   */
  const swtichZnt = (id) => {
    if (window.zdSearch) {
      id && setActiveMenu("brain");
      id && setShowActiveMeau(true);
    } else {
      id && setActiveMenu("chat");
    }

    id && setNewRefresh(Math.random());
    if (window.zdShowHisSelect) {
      id && setHistorySearchId(id);
    }
    //navigate(`/?znwdId=${key?.key ?? ""}`, { replace: true })
    // window.history.pushState({}, "", getChatUrl(id, embed));
    // console.log(getChatUrl(id, embed), "这是啥")
    // navigate(getChatUrl(id, embed), { replace: true })
    if (single) {
      // window.location.href = getChatUrl(id, embed, single ? true : false);
      window.open(getChatUrl(id, embed, single), "_agent");
    } else {
      window.history.pushState({}, "", getChatUrl(id, embed));
    }
    setZnwtId(id + "");
    setItems([]);
    stopAudio();
    chatBoxRef.current?.senderBox.setContent("");
  };

  //初始化接口
  const {
    runAsync: requestInit,
    loading: loadingInitData,
    data: initData,
  } = useBaseRequest(() => getInitData(znwdId ? { znwdId } : {}), {
    // manual: true,
    onSuccess(res) {
      setHotList(res?.data?.hotqas?.slice(0, 6));
      const arr = [];
      setZskData([
        {
          key: "all",
          label: "全部知识库",
        },
        ...res?.data?.zskList?.map((item) => {
          return {
            key: item.id,
            label: item.name,
          };
        }),
      ]);

      const models = res?.data?.llmlist || [];
      setMoreModel([
        ...models.map((item) => {
          return {
            key: item.id,
            label: item.name,
          };
        }),
      ]);
      setSelectedModelValue({
        key: models?.[0] ? models?.[0].id : "",
        label: models?.[0] ? models?.[0].name : "",
      });

      // if (res?.data?.znttype === 2) {
      runGetAllSkill(res?.data?.id);
      // }
      // runGetAllSkill()
      initDataRef.current = res;
      setPortalSearch(res?.data?.portalSearch);
      setSiteSearch(res?.data?.siteSearch);
      setInternetSearch(res?.data?.internetSearch);
      setAgentName(res?.data?.name);
      // setHistorySearchId((res?.data?.id ?? "") + "");
      //res.data?.socketId && useSessionStore.set("userUid", res.data?.socketId)

      const tabArr = transformDataToTabsWithAllEnhanced(res?.data?.hotqas);
      setTabs(tabArr);
    },
    refreshDeps: [znwdId],
  });

  const transformDataToTabsWithAllEnhanced = (data) => {
    const groupedData = data.reduce((acc, item) => {
      const { categoryId, categoryName, id, name } = item;

      if (!acc[categoryId]) {
        acc[categoryId] = {
          key: categoryId,
          label: categoryName,
          children: [],
        };
      }

      acc[categoryId].children.push({
        id: id,
        name: name,
        categoryName: categoryName,
        categoryId: categoryId,
      });

      return acc;
    }, {});

    const tabsArray = Object.values(groupedData);

    // 创建"全部"页签，包含分类信息
    const allTab = {
      key: "all",
      label: "全部",
      children: data.map((item) => ({
        id: item.id,
        name: item.name,
        categoryName: item.categoryName,
        categoryId: item.categoryId,
        // 添加分类标签显示
        displayName: `[${item.categoryName}] ${item.name}`,
      })),
    };
    setAllLength(tabsArray.length);
    return [allTab, ...tabsArray];
  };

  const [selectData, setSelectData] = useState([]);

  useEffect(() => {
    if (!window.location.href.includes("#/single")) {
      runGetcategaryList();
    }
  }, []);

  //新建会话
  const {
    data: allZntList,
    loading,
    refresh,
    runAsync: runGetcategaryList,
  } = useBaseRequest(() => getcategaryList("0"), {
    manual: true,
    onSuccess: (res) => {
      const data = res?.data;
      const newArr = [];
      data.map((item) => {
        if (isMobile) {
          if (item?.alloweddevice * 1 === 2 || item?.alloweddevice * 1 === 0) {
            newArr.push({
              label: item.name,
              value: item.id,
              outerznt: item.outerznt,
              outerurl: item.outerurl,
            });
          }
        } else {
          if (item?.alloweddevice * 1 === 0 || item?.alloweddevice === 1) {
            newArr.push({
              label: item.name,
              value: item.id,
              outerznt: item.outerznt,
              outerurl: item.outerurl,
            });
          }
        }
      });
      setSelectData(newArr);
    },
  });
  //获取所有的智能体
  const {
    data: getNewChatData,
    loading: getNewChatLoading,
    runAsync: runGetNewChat,
  } = useBaseRequest((params) => getNewChat(params), {
    manual: true,
    ready: initData?.data?.id ? true : false,
    //refreshDeps: [initData?.data?.id],
  });

  //获取所有的任务列表
  const {
    data: getAllSkillData,
    loading: getAllSkillLoading,
    runAsync: runGetAllSkill,
  } = useBaseRequest((params) => getSkillList(params), {
    manual: true,
    onSuccess: (res) => {
      setSkillList(res?.data);
    },
  });

  //更新会话
  const {
    data: getUpdateChatData,
    loading: getUpdateChatLoading,
    runAsync: runGetUpdateChat,
  } = useBaseRequest((params) => getUpdateChat(params), {
    manual: true,
    //refreshDeps: [initData?.data?.id],
    onSuccess(res) {
      runGetSessionList();
      setRenameData({});
      setReNameOpen(false);
    },
  });
  //删除回话
  const {
    data: getDeleteChatData,
    loading: getDeleteChatLoading,
    runAsync: runGetDeleteChat,
  } = useBaseRequest((params) => getDeleteChat(params), {
    manual: true,
    onSuccess(res) {
      if (newMode === "single") {
        if (historyKey === deleteKey) {
          runGetSessionList();
          setRefreshHistory(Math.random());
          swtichZnt("");
          swtichChat("", "");
        } else {
          // swtichZnt(historyKey)
          runGetSessionList();
          setRefreshHistory(Math.random());
        }
      } else {
        if (selectedKey === deleteKey) {
          runGetSessionList();
          setRefreshHistory(Math.random());
          swtichZnt("");
          swtichChat("", "");
        } else {
          runGetSessionList();
          setRefreshHistory(Math.random());
          // swtichChat(selectedKey);
        }
      }
    },
  });

  //查询会话历史
  const {
    data: getSessionListData,
    loading: getSessionListLoading,
    runAsync: runGetSessionList,
    refresh: refreshGetSessionList,
  } = useBaseRequest((params) => getSessionList(params), {
    manual: true,
    refreshDeps: [newMode, historySearchId],
  });

  useEffect(() => {
    if (newMode === "single") {
      runGetSessionList({
        zntId: historySearchId === "all" ? "" : historySearchId,
        count: 50,
      });
    }
    if (newMode === "multiple") {
      runGetSessionList({
        zntId: historySearchId === "all" ? "" : historySearchId,
        count: 30,
      });
    }
    // runGetSessionList();
    // }, [historySearchId]);
  }, [historySearchId, refreshHistory]);
  //是否是默认智能体
  const isDefaultAgent = useMemo(() => {
    if (
      initData?.data?.id &&
      !getUrlParam("znwdId") &&
      !getUrlParam("chatId")
    ) {
      return true;
    }
    return false;
  }, [initData?.data?.id, znwdId, refreshNew, newRefresh]);

  //当前使用的智能体信息
  const curZnt = useMemo(() => {
    return allZntList?.data?.filter((element) => element.id == znwdId)?.[0];
  }, [znwdId, allZntList?.data, newRefresh]);
  const userUid = initData?.data?.socketId;
  // const { readyState, sendMessage, latestMessage, disconnect, connect } = useWebSocket(
  //   userUid ? `${API.serSocket}/${userUid}` : "",
  //   {
  //     onClose(event, instance) {
  //       console.log("onClose", event, instance)
  //     },
  //     onError(event, instance) {},
  //     onOpen(event, instance) {
  //       console.log("onOpen", event, instance)
  //     },
  //   }
  // )

  const { isMobile } = useBrowserClient(768);
  const [sending, setSending] = useState(false);
  const [receiving, setReceiving] = useState(false);
  const chatId = useRef(getUrlParam("chatId") ?? "");
  const [_chatCache, set_chatCache] = useState();
  const chatBoxRef = useRef(null);
  const sendingRef = useRef();
  const [hotList, setHotList] = useState([]);
  const receivingRef = useRef();
  const [deepthink, setDeepthink] = useState(true);
  const [portalSearch, setPortalSearch] = useState(false);
  const [siteSearch, setSiteSearch] = useState(false);
  const [internetSearch, setInternetSearch] = useState(false);
  const [helpOpen, setHelpOpen] = useState(true);
  const [helpData, setHelpData] = useState([]);
  const [timenum, setTime] = useState(15000);
  const lastHistoryMessage = useMemo(() => {
    return items?.length ? items?.[items?.length - 1] : null;
  }, [items]);

  console.log("最后一条数据", lastHistoryMessage);
  /**
   * 切换对话
   * @param id
   */
  const swtichChat = (id, dId) => {
    chatHistoryDate.current = "";
    id && setActiveMenu("chat");
    //navigate(`/?znwdId=${key?.key ?? ""}`, { replace: true })
    setItems([]);
    if (newMode === "single") {
      let dhisId = getUrlParam("znwdId");
      let url = `./${location.hash}`;
      if (id) {
        url = `./?chatId=${id ?? ""}${embed ? "&embed=1" : ""}${location.hash}`;
        if (dhisId) {
          url = `./?chatId=${id ?? ""}&znwdId=${dhisId}${
            embed ? "&embed=1" : ""
          }${location.hash}`;
        }
        setHistoryKey("-1");
      } else {
        if (dhisId) {
          url = `./?znwdId=${dhisId}${embed ? "&embed=1" : ""}${location.hash}`;
        }
      }
      window.history.pushState({}, "", url);
      chatId.current = id + "";
      setItems([]);
      setHistoryKey("-1");
      setA("");
      if (id) {
        requestHistoryData(id);
      }
    } else {
      let url = "./";
      if (id) {
        url = `./?chatId=${id ?? ""}${embed ? "&embed=1" : ""}`;
        if (dId) {
          url = `./?chatId=${id ?? ""}&znwdId=${dId}${embed ? "&embed=1" : ""}`;
        }
      } else {
        if (dId) {
          url = `./?znwdId=${dId}${embed ? "&embed=1" : ""}`;
        }
      }
      window.history.pushState({}, "", url);
      chatId.current = id + "";
      setItems([]);
      setA("");
      setSelectedValue({
        key: "all",
        label: "全部知识库",
      });
      setFileList([]);
      setFileOpen(false);
      if (id) {
        requestHistoryData(id);
      }
    }

    // window.history.pushState({}, "", id ? `./?chatId=${id ?? ""}&znwdId=${znwdId}` : "./");
  };
  //任务智能体插槽相关
  const [newInputSubmit, setNewInputSubmit] = useState(false);
  const [newInputId, setNewInputId] = useState("");

  const StartChat = async (msg, params, ifskill, newData) => {
    if (!chatId.current) {
      const chatIdRes = await runGetNewChat({
        zntId: initData?.data?.id,
        title: msg ? encodeURIComponent(msg) : " ",
        // title: msg,
      });
      if (chatIdRes?.data?.chatId) {
        chatId.current = chatIdRes?.data?.chatId;
        set_chatCache(chatIdRes?.data?.chatId);
        setTimeout(() => {
          startChat(msg, params, ifskill, newData);
        }, 0);
      }
    } else {
      startChat(msg, params, ifskill, newData);
    }
  };
  const startChat = (msg, params, ifskill, newData) => {
    if (!msg) {
      // alert('我提交了')
      return message.info("请输入您的问题");
    }
    if (receiving || sending || sendingRef.current || receivingRef.current) {
      // return message.warning('正在处理...')
      return;
    }
    sendingRef.current = true;

    chatBoxRef.current?.senderBox?.clear();
    // sendHandler(msg)
    setMode("conversation");
    setSending(true);
    const qId = uuidv4().replaceAll("-", "");

    //preCall表单
    let preCallData =
      lastHistoryMessage?.data?.form?.type === "preCall" && params
        ? {
            question: lastHistoryMessage?.data?.form?.question,
            query: lastHistoryMessage?.data?.form?.query,
            params: { ...(params ?? {}) },
          }
        : undefined;
    //useSessionStore.set(`q_${qId}`, _id)

    if (ifskill) {
      preCallData = {
        question: newData?.skill,
        query: newData?.question,
        params: { ...(newData?.params ?? {}) },
      };
    }

    if (newInputSubmit) {
      preCallData = {
        question: newInputId,
        query: msg,
        params: { ...(params ?? {}) },
      };
    }
    wsRef.current?.send(
      JSON.stringify({
        msgType: "query",
        msgData: {
          query: msg,
          model: selectedModelValue.key || "",
          form: preCallData,
          llmFlag: deepthink ? "1" : "0",
          // llmFlag: clickActive ? "1" : "0",
          deep_thinking: deepthink ? "1" : "0",
          internetSearch,
          portalSearch,
          siteSearch,
          s_Path: "",
          command: "",
          qId,
          kb_ids: zskDisabled
            ? ["-1"]
            : selectedValue?.key === "all"
            ? null
            : [selectedValue?.key],
          files: fileList,
        },
      }),
      {
        url: `${API.serSocket}/${userUid}?chatId=${chatId.current}`,
      }
      //{ url: `${API.serSocket}/${userUid}?chatId=${chatId.current}` }
    );
    setItems((v) => {
      const item = {
        key: v.length + 1,
        loading: true,
        role: "ai",
        qId,
        content: "",
        data: {},
        typing: true,
        messageRender: (content, { MessageMarkdown, item }) => {
          const taskList = item?.data?.tasklist || [];
          if (item?.data?.progress && !taskList.length) {
            return (
              <Flex align={"center"} gap={8}>
                {item?.content === "已经取消" ? (
                  item?.content
                ) : (
                  <>
                    <span key="loading">{item?.data?.progress?.title}</span>
                    <ChatLoadingDots />
                  </>
                )}
              </Flex>
            );
          }
          if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
            return (
              <div
                key={"progress"}
                style={{
                  width: "100%",
                }}
              >
                {(taskList?.length ? taskList : []).map((jtem, inde) => {
                  if (jtem.form && jtem.form.type === "link") {
                    return (
                      <div className="sui-chatui-bubble-iframe">
                        <iframe
                          width={"100%"}
                          style={{
                            height: jtem.form?.height
                              ? `${jtem.form?.height}px`
                              : "300px",
                            border: "unset",
                          }}
                          src={jtem.form.url}
                        ></iframe>
                      </div>
                    );
                  }
                  return (
                    <div key={inde}>
                      <div
                        style={{
                          fontSize: "12px",
                          padding: "5px 0",
                        }}
                      >
                        <span key={jtem.status}>
                          {handleStatus(jtem.status || "")}
                        </span>
                        <span
                          style={{
                            verticalAlign: "middle",
                            color: "#bbb",
                            paddingLeft: "4px",
                          }}
                          key={jtem.name}
                        >
                          {jtem.name || ""}
                        </span>
                      </div>
                      <MessageMarkdown autoLink={true}>
                        {jtem.result ? jtem.result : ""}
                      </MessageMarkdown>
                    </div>
                  );
                })}
              </div>
            );
          }
        },
      };
      lastItemRef.current = item;
      return [
        ...v,
        {
          key: v.length,
          content: msg,
          role: "user",
          footer:
            fileList && fileList.length ? (
              <div className="allowFile">
                <Attachments
                  className="uploadDisable"
                  items={fileList}
                  overflow="scrollX"
                  disabled={true}
                />
              </div>
            ) : (
              ""
            ),
        },
        item,
      ];
    });
    setFileOpen(false);
    setSending(false);
    sendingRef.current = false;
    receivingRef.current = true;
    setReceiving(true);
    setNewInputSubmit(false);
    setNewInputId("");
    setSkillName("");
  };
  const slotInput =
    lastHistoryMessage?.data?.form?.type === "preCall" &&
    lastHistoryMessage?.data?.form?.params?.length &&
    !lastHistoryMessage.typing &&
    !lastHistoryMessage.loading
      ? {
          slots: lastHistoryMessage?.data?.form?.params?.map((param) => ({
            name: param?.field,
            label: param?.fieldName,
            required: param?.required,
            defaultValue: param?.value,
            placeholder: param?.example,
            query: param?.query,
          })),
        }
      : undefined;
  const [newSoltInput, setNewSoltInput] = useState(undefined);

  useEffect(() => {
    if (
      lastHistoryMessage?.data?.form?.type === "preCall" &&
      lastHistoryMessage?.data?.form?.params?.length &&
      !lastHistoryMessage.typing &&
      !lastHistoryMessage.loading
    ) {
      setNewSoltInput({
        slots: lastHistoryMessage?.data?.form?.params?.map((param) => ({
          name: param?.field,
          label: param?.fieldName,
          required: param?.required,
          defaultValue: param?.value,
          placeholder: param?.example,
          query: param?.query,
        })),
      });
    } else {
      setNewSoltInput(undefined);
    }
  }, [items]);

  console.log(newSoltInput, "新的插槽数据");

  const handleStatus = (status) => {
    // status = 1
    //0 待处理 1 处理中 2 成功 3 失败
    if (status === 0) {
      return <img key="DclPic" src={DclPic} alt=" " />;
    } else if (status === 1) {
      return <img key="HandlingPic" src={HandlingPic} alt=" " />;
    } else if (status === 2) {
      return <img key="SuccessPic" src={SuccessPic} alt=" " />;
    } else if (status === 3) {
      return <img key="ErrorPic" src={ErrorPic} alt=" " />;
    } else {
      return " ";
    }
  };

  const handler = (_data) => {
    if (newMode === "single") {
      setSending(false);
    }
    sendingRef.current = false;
    if (_data) {
      const qId = _data.qId;
      if (lastItemRef.current && lastItemRef.current.qId) {
        lastItemRef.current.loading = false;
        lastItemRef.current.data = _data;
        lastItemRef.current.typing = !_data.isFinished;
        lastItemRef.current.process = _data.progress;
        // lastItemRef.current.srcs = parseSrcs(_data,);
        lastItemRef.current.srcs = parseSrcs({
          ..._data,
          //   form: { type: "link", url: "http://localhost:3001/" },
        });
        lastItemRef.current.content = parseContent(_data);

        if (_data.isFinished) {
          lastItemRef.current.prompts = _data?.guess;
          lastItemRef.current.extra = parseExtra(_data);
          lastItemRef.current.source = parseSource(
            _data,
            initDataRef?.current?.data?.zskList
          );
        }
        setItems((v) => {
          return [...v];
        });
      }

      if (_data.isFinished) {
        lastItemRef.current = null;
        receivingRef.current = false;
        if (
          initDataRef.current?.data?.talkSpeed &&
          initDataRef.current?.data?.talkSpeed > 0
        ) {
          window.sessionStorage.setItem("time", JSON.stringify(new Date()));
          setReceiving({
            delay: initDataRef.current?.data?.talkSpeed * 1000,
            onEnd() {
              setReceiving(false);
            },
          });
        } else {
          setReceiving(false);
        }
        //刷新左侧对话历史
        // runGetSessionList();
        setHistorySearchId(initDataRef?.current?.data?.id);
        setRefreshHistory(Math.random());
      }
    }
  };

  const handleTime = () => {
    const time = window.sessionStorage.getItem("time");

    if (time) {
      const targetDate = new Date(JSON.parse(time));
      const currentDate = new Date();
      const diffMilliseconds = currentDate.getTime() - targetDate.getTime();
      // 转换为整数秒
      const diffSeconds = Math.floor(diffMilliseconds / 1000);
      let time1 = initData?.data?.talkSpeed * 1000;
      if (initData?.data?.talkSpeed && initData?.data?.talkSpeed > 0) {
        if (diffSeconds > 0 && diffSeconds < initData?.data?.talkSpeed) {
          time1 = (initData?.data?.talkSpeed - diffSeconds) * 1000;
        }
        if (diffSeconds >= initData?.data?.talkSpeed || diffSeconds <= 0) {
          setReceiving(false);
        } else {
          setReceiving({
            delay: time1,
            onEnd: function () {
              setReceiving(false);
            },
          });
        }
      } else {
        setReceiving(false);
      }
    } else {
      setReceiving(false);
    }
  };

  useEffect(() => {
    handleTime();
  }, [initData?.data?.talkSpeed]);

  useEffect(() => {
    const id = getUrlParam("znwdId");
    if (id) {
      setZnwtId(id);
      if (window.zdShowHisSelect) {
        setHistorySearchId(id);
      }
    }
  }, []);

  const wsRef = useWebSocketClient(
    userUid && chatId.current
      ? `${API.serSocket}/${userUid}?chatId=${chatId.current}`
      : "",
    {
      onMessage(data) {
        if (data === "pong" || data === "ping") {
          return;
        }
        try {
          handler(parseResponse(data));
        } catch (error) {}
      },
      onClose() {
        receivingRef.current = false;
        setReceiving(false);
      },
    }
  );

  // useEffect(() => {
  //   if (latestMessage?.data === "ping" || latestMessage?.data === "pong") {
  //     return
  //   }

  //   if (latestMessage?.data) {
  //     handler(parseResponse(latestMessage))
  //   }
  // }, [latestMessage])
  const { run: requestEvaluate, runAsync: requestEvaluateAsync } =
    useBaseRequest(getEvaluateData, {
      manual: true,
      onSuccess(res) {
        message.success("感谢您的支持");
      },
    });
  const chatHistoryDate = useRef("");
  //const [chatHistroy1, setchatHistroy1] = useState<any>()
  // useEffect(() => {
  //   hisMockResponse({ count: 10, date: chatHistoryDate.current, id: znwdId }).then((res) => {
  //     setchatHistroy1(res)
  //   })
  // }, [])
  // const {
  //   runAsync: requestHistoryData,
  //   data: chatHistroy,
  //   loading: chatHistoryLoading,
  // } = useBaseRequest(
  //   (date: string = "", id?: string) => getChatList({ id: id ?? znwdId, count: 10, date }),
  //   {
  //     ready: znwdId ? true : false,
  //     //refreshDeps: [znwdId],
  //     onSuccess: (res: any) => {
  //       if (res?.data?.length) {
  //         chatHistoryDate.current = res?.data?.[res?.data?.length - 1]?.time ?? ""
  //       }
  //     },
  //   }
  // )

  const [showIframe, setShowIframe] = useState(false);
  const [a, setA] = useState(undefined);
  const historyRef = useRef();

  useEffect(() => {
    if (showIframe) {
      let _items = [];
      historyRef?.current?.forEach((item, dindex) => {
        _items.push({
          role: "user",
          content: item?.qa?.query ?? "",
          //key: uuidv4().replaceAll("-", ""),
          footer:
            item?.qa?.files && item?.qa?.files.length ? (
              <div className="allowFile">
                <Attachments
                  className="uploadDisable"
                  items={item?.qa?.files}
                  overflow="scrollX"
                  disabled={true}
                />
              </div>
            ) : (
              ""
            ),
        });
        _items.push({
          role: "ai",
          qId: item?.qa?.qId,
          loading: false,
          typing: false,
          //key: uuidv4().replaceAll("-", ""),
          data: item?.qa,
          content: parseContent(item?.qa),
          messageRender: (content, { MessageMarkdown, item }) => {
            console.log(item, content, a, "历史记录啥的");
            const taskList = item?.data?.tasklist || [];
            if (item?.data?.progress && !taskList.length) {
              return (
                <Flex align={"center"} gap={8}>
                  {item?.content === "已经取消" ? (
                    item?.content
                  ) : (
                    <>
                      <span key="loading">{item?.data?.progress?.title}</span>
                      <ChatLoadingDots />
                    </>
                  )}
                  {/* <span key='loading'>{item?.data?.progress?.title}</span>
                                    <ChatLoadingDots /> */}
                </Flex>
              );
            }
            if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
              // if (item.data?.answer) {
              //     return <Markdown>{item.data?.answer}</Markdown>
              // } else {
              //     if (showIframe && a === dindex) {
              //         return <div key={'progress'}>
              //             {(taskList?.length ? taskList : []).map((jtem, inde) => {
              //                 if (jtem.form && jtem.form.type === "link") {
              //                     return <div className="sui-chatui-bubble-iframe">
              //                         <iframe className="insetIframe" width={"100%"} style={{
              //                             height: jtem.form?.height ? `${jtem.form?.height}px` : "300px",
              //                             border: 'unset'
              //                         }} src={jtem.form.url} ></iframe>
              //                     </div>
              //                 }
              //                 return (<div key={inde}>
              //                     <div style={{
              //                         fontSize: "12px",
              //                         padding: "5px 0"
              //                     }} ><span key={jtem.status}>{handleStatus(jtem.status || '')}</span><span style={{
              //                         verticalAlign: "middle",
              //                         color: "#bbb",
              //                         paddingLeft: "4px"
              //                     }} key={jtem.name}>{jtem.name || ''}</span></div>
              //                     <Markdown>{jtem.result ? jtem.result : ''}</Markdown>
              //                 </div>)
              //             })}
              //         </div>
              //     } else {
              //         return <div style={{
              //             fontSize: "12px",
              //             cursor: "pointer"
              //         }} onClick={() => {
              //             setShowIframe((v) => !v)
              //             setA(dindex)
              //         }}>点击刷新</div>
              //     }
              // }
              return (
                <div key={"progress"}>
                  {(taskList?.length ? taskList : []).map((jtem, inde) => {
                    if (jtem.form && jtem.form.type === "link") {
                      if (item.data?.answer) {
                        return (
                          <MessageMarkdown autoLink={true}>{item.data?.answer}</MessageMarkdown>
                        );
                      }
                      if (showIframe && a === dindex) {
                        return (
                          <div className="sui-chatui-bubble-iframe">
                            <iframe
                              className="insetIframe"
                              width={"100%"}
                              style={{
                                height: jtem.form?.height
                                  ? `${jtem.form?.height}px`
                                  : "300px",
                                border: "unset",
                              }}
                              src={jtem.form.url}
                            ></iframe>
                          </div>
                        );
                      } else {
                        return (
                          <div
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setShowIframe((v) => !v);
                              setA(dindex);
                            }}
                          >
                            点击刷新
                          </div>
                        );
                      }
                    }
                    return (
                      <div key={inde}>
                        <div
                          style={{
                            fontSize: "12px",
                            padding: "5px 0",
                          }}
                        >
                          <span key={jtem.status}>
                            {handleStatus(jtem.status || "")}
                          </span>
                          <span
                            style={{
                              verticalAlign: "middle",
                              color: "#bbb",
                              paddingLeft: "4px",
                            }}
                            key={jtem.name}
                          >
                            {jtem.name || ""}
                          </span>
                        </div>
                        <MessageMarkdown autoLink={true}>
                          {jtem.result ? jtem.result : ""}
                        </MessageMarkdown>
                      </div>
                    );
                  })}
                </div>
              );
            }
          },
          srcs: parseSrcs(item?.qa),
          prompts: item?.guess || item?.qa?.guess,
          source: parseSource(item?.qa, initDataRef?.current?.data?.zskList),
          extra: parseExtra(item?.qa),
          defaultOpenSrcs: false, // 默认不打开历史消息的外链页面
        });
      });
      setItems((v) => [..._items]);
    }
  }, [showIframe]);

  const {
    runAsync: requestHistoryData,
    data: chatHistroy,
    loading: chatHistoryLoading,
  } = useBaseRequest((id) => getSessionHistory(id), {
    //ready: znwdId ? true : false,
    manual: true,
    //refreshDeps: [znwdId],
    onSuccess: (res) => {
      if (res?.data?.length) {
        // chatHistoryDate.current = res?.data?.[res?.data?.length - 1]?.time ?? ""
        historyRef.current = [...(res?.data ?? [])]?.reverse?.();
        const _items = [];
        [...(res?.data ?? [])]?.reverse?.()?.forEach((item, dindex) => {
          _items.push({
            role: "user",
            content: item?.qa?.query ?? "",
            //key: uuidv4().replaceAll("-", ""),
            footer:
              item?.qa?.files && item?.qa?.files.length ? (
                <div className="allowFile">
                  <Attachments
                    className="uploadDisable"
                    items={item?.qa?.files}
                    overflow="scrollX"
                    disabled={true}
                  />
                </div>
              ) : (
                ""
              ),
          });
          _items.push({
            role: "ai",
            qId: item?.qa?.qId,
            loading: false,
            typing: false,
            //key: uuidv4().replaceAll("-", ""),
            data: item?.qa,
            content: parseContent(item?.qa),
            messageRender: (content, { MessageMarkdown, item }) => {
              console.log(item, content, a, "历史记录啥的");
              const taskList = item?.data?.tasklist || [];
              if (item?.data?.progress && !taskList.length) {
                return (
                  <Flex align={"center"} gap={8}>
                    {item?.content === "已经取消" ? (
                      item?.content
                    ) : (
                      <>
                        <span key="loading">{item?.data?.progress?.title}</span>
                        <ChatLoadingDots />
                      </>
                    )}
                    {/* <span key='loading'>{item?.data?.progress?.title}</span>
                                        <ChatLoadingDots /> */}
                  </Flex>
                );
              }
              if (
                initDataRef?.current?.data?.znttype === 2 &&
                taskList.length
              ) {
                return (
                  <div key={"progress"}>
                    {(taskList?.length ? taskList : []).map((jtem, inde) => {
                      if (jtem.form && jtem.form.type === "link") {
                        if (item.data?.answer) {
                          return (
                            <MessageMarkdown autoLink={true}>
                              {item.data?.answer}
                            </MessageMarkdown>
                          );
                        }
                        if (showIframe && a === dindex) {
                          return (
                            <div className="sui-chatui-bubble-iframe">
                              <iframe
                                className="insetIframe"
                                width={"100%"}
                                style={{
                                  height: jtem.form?.height
                                    ? `${jtem.form?.height}px`
                                    : "300px",
                                  border: "unset",
                                }}
                                src={jtem.form.url}
                              ></iframe>
                            </div>
                          );
                        } else {
                          return (
                            <div
                              style={{
                                fontSize: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setShowIframe((v) => !v);
                                setA(dindex);
                              }}
                            >
                              点击刷新
                            </div>
                          );
                        }
                      }
                      return (
                        <div key={inde}>
                          <div
                            style={{
                              fontSize: "12px",
                              padding: "5px 0",
                            }}
                          >
                            <span key={jtem.status}>
                              {handleStatus(jtem.status || "")}
                            </span>
                            <span
                              style={{
                                verticalAlign: "middle",
                                color: "#bbb",
                                paddingLeft: "4px",
                              }}
                              key={jtem.name}
                            >
                              {jtem.name || ""}
                            </span>
                          </div>
                          <MessageMarkdown autoLink={true}>
                            {jtem.result ? jtem.result : ""}
                          </MessageMarkdown>
                        </div>
                      );
                    })}
                  </div>
                );
              }
            },
            srcs: parseSrcs({
              ...item?.qa,
              //   form: { type: "link", url: "http://localhost:3001/" },
            }),
            prompts: item?.guess || item?.qa?.guess,
            source: parseSource(item?.qa, initDataRef?.current?.data?.zskList),
            extra: parseExtra(item?.qa),
            defaultOpenSrcs: false, // 默认不打开历史消息的外链页面
          });
        });
        setItems((v) => [..._items, ...v]);
      }
    },
  });
  useEffect(() => {
    if (chatId?.current) {
      requestHistoryData(chatId.current);
    }
  }, []);

  const onSendHistory = (key, item) => {
    handleTime();
    setHelpOpen(true);
    swtichChat(key, "");
    setHistoryKey(key);
    setFileList([]);
    setFileOpen(false);
    stopRecording();
    setShowActiveMeau(false);
    chatBoxRef.current?.senderBox.setContent("");
  };
  const handleEvaluate = (rate, str, chatInstance = {}) => {
    const { qId: msgId, data } = chatInstance;
    const {
      query,
      answer,
      content,
      html,
      s_Path,
      s_Date,
      knowledge_id,
      knowledge_type,
      graph,
      relaItems = [],
      // reference: { referenceList = [] },
      reference = [],
      urlList = [],
      attachmentList = [],
    } = data;

    const obj = {
      qId: msgId,
      question: query,
      answer: answer || content || html || "AI",
      score: rate === "good" ? 5 : 1,
      date: s_Date,
      knowledge_id,
      knowledge_type,
      suggestion: "",
    };

    if (str) {
      obj.suggestion = str;
    }
    if (s_Path) {
      obj.graph = 1;
      obj.question = s_Path + "/" + query;
      obj.answer = graph?.answer;
    }
    if (relaItems.length) {
      obj.refItems = JSON.stringify(relaItems);
    }
    // if (referenceList && referenceList.length) {
    //   obj.references = JSON.stringify(referenceList);
    // }
    if (reference && reference.length) {
      obj.references = JSON.stringify(reference);
    }
    if (urlList.length) {
      obj.links = JSON.stringify(urlList);
    }
    if (attachmentList.length) {
      obj.attachments = JSON.stringify(attachmentList);
    }
    requestEvaluateAsync(obj).then((res) => {
      if (res) {
        message.success(rate === "good" ? "感谢您的支持" : "感谢您的反馈");
      }
    });
  };
  const [feedback, setFeedback] = useState(null);
  const promptsItems = hotList?.length
    ? hotList.map((subject) => {
        return {
          key: subject.id,
          description: subject.name,
        };
      })
    : undefined;
  useEffect(() => {
    // const _items: Array<ChatMessageDataType & { qId?: string }> = [];
    // //有历史记录
    // if (chatHistroy?.data?.length) {
    //     [...(chatHistroy?.data ?? [])]?.reverse?.()?.forEach((item: any) => {
    //         console.log(item, "11223131313123历史对话")
    //         _items.push({
    //             role: "user",
    //             content: item?.qa?.query ?? "",
    //             //key: uuidv4().replaceAll("-", ""),
    //             footer: (item?.qa?.files && item?.qa?.files.length) ? <div className="allowFile">
    //                 <Attachments
    //                     className="uploadDisable"
    //                     items={item?.qa?.files}
    //                     overflow="scrollX"
    //                     disabled={true}
    //                 />
    //             </div> : ""
    //         });
    //         _items.push({
    //             role: "ai",
    //             qId: item?.qa?.qId,
    //             loading: false,
    //             typing: false,
    //             //key: uuidv4().replaceAll("-", ""),
    //             data: item?.qa,
    //             content: parseContent(item?.qa),
    //             messageRender: (content, { Markdown, item }) => {
    //                 console.log(content, item)
    //                 const taskList = item?.data?.tasklist || [];
    //                 if (item?.data?.progress && !taskList.length) {
    //                     return (
    //                         <Flex align={'center'} gap={8}>
    //                             <span key='loading'>{item?.data?.progress?.title}</span>
    //                             <ChatLoadingDots />
    //                         </Flex>
    //                     );
    //                 }
    //                 if (initDataRef?.current?.data?.znttype === 2 && taskList.length) {
    //                     return <div key={'progress'}>
    //                         {(taskList?.length ? taskList : []).map((jtem: any, inde: any) => {
    //                             console.log(jtem)
    //                             return (<div key={inde}>
    //                                 <div style={{
    //                                     fontSize: "12px",
    //                                     padding: "5px 0"
    //                                 }} ><span key={jtem.status}>{handleStatus(jtem.status || '')}</span><span style={{
    //                                     verticalAlign: "middle",
    //                                     color: "#bbb",
    //                                     paddingLeft: "4px"
    //                                 }} key={jtem.name}>{jtem.name || ''}</span></div>
    //                                 <Markdown>{jtem.result ? jtem.result : ''}</Markdown>
    //                             </div>)
    //                         })}
    //                     </div>
    //                 }
    //             },
    //             srcs: parseSrcs(item?.qa),
    //             prompts: item?.guess || item?.qa?.guess,
    //             source: parseSource(item?.qa),
    //             extra: parseExtra(item?.qa),
    //             defaultOpenSrcs: false // 默认不打开历史消息的外链页面
    //         });
    //     });
    // }
    // setItems((v) => [..._items, ...v]);
  }, [chatHistroy?.data, initData?.data?.znttype]);

  useEffect(() => {
    console.log(items, "切换之后的items是不是改变了");
    setMode(items?.length ? "conversation" : "welcome");
    //智能体直接进入对话模式
    if (!isDefaultAgent && !single) {
      // _items.push({
      //   role: "ai",
      //   content: "placeholder",
      //   loading: false,
      //   typing: false,
      //   qId: "placeholder-context",
      //   key: _items?.length,
      // })
      setMode("conversation");
    }
  }, [items, isDefaultAgent, single]);
  useEffect(() => {
    if (!loadingInitData) {
      document.title = initData ? initData?.data?.sysname || "" : "";
    } else {
      document.title = window.location.host;
    }
  }, [initData?.data?.sysname, znwdId, newRefresh]);

  useEffect(() => {
    if (renameOpen) {
      renameForm?.setFieldValue("name", renameData?.name);
    }
  }, [renameOpen]);

  //检验用户是否登录
  useEffect(() => {
    if (single) {
      return;
    }
    if (!initData?.data?.userId && initData?.data?.forcelogin === 1) {
      if (process.env.NODE_ENV === "development") {
        return;
      }
      const baseUrl = window.location.protocol + "//" + window.location.host;
      const hash = window.location.hash;
      const url = new URL(initData?.data?.loginUrl, baseUrl);
      if (window.location.href.includes("#/single")) {
        url.searchParams.set("znwdId", initData?.data?.id);
        // window.location.href = initData?.data?.loginUrl + `?znwdId=${initData?.data?.id}`;
        if (hash) {
          window.sessionStorage.setItem("hash", hash);
        }

        window.location.href = url.toString();
      } else if (window.location.href.includes("#/newChat")) {
        url.searchParams.set("znwdId", znwdId);
        if (hash) {
          window.sessionStorage.setItem("hash", hash);
        }
      } else {
        window.location.href = initData?.data?.loginUrl;
      }
    } else {
      const newhash = window.sessionStorage.getItem("hash");
      if (newhash) {
        if (window.location.href.includes("#/single")) {
          window.location.href = window.location.href;
          return;
        }
        if (window.location.href.includes("#/newChat")) {
          window.sessionStorage.removeItem("hash");
          window.location.href = window.location.href;
          return;
        }
        window.location.href = window.location.href + newhash;
        window.sessionStorage.removeItem("hash");
      }
    }
  }, [initData?.data]);

  //刷新热门

  const nextHots = useArraySlicer(initData?.data?.hotqas, 6);
  const onReloadHots = () => {
    setHotList(nextHots());
  };

  console.log(
    2120,
    items,
    chatId.current,
    znwdId,
    activeMenu,
    curZnt,
    isDefaultAgent,
    tabs,
    getNewChatData,
    mode,
    allZntList,
    "这个mode是啥"
  );
  const cancelHandler = () => {
    if (lastItemRef.current?.typing) {
      manualStoppedMsgIds.push(lastItemRef.current?.qId ?? "");
      wsRef.current?.send(
        JSON.stringify(
          BgCmdMessage({
            msgId: lastItemRef.current?.qId ?? "",
            command: "shutdown",
          })
        ),
        {
          url: `${API.serSocket}/${userUid}?chatId=${chatId.current}`,
        }
      );
    }
    if (lastItemRef.current) {
      lastItemRef.current.loading = false;
      lastItemRef.current.typing = false;
      lastItemRef.current.content = "已经取消";
    }
    lastItemRef.current = null;
    setSending(false);
    setReceiving(false);
    sendingRef.current = false;
    receivingRef.current = false;
    wsRef.current?.close();
  };

  //录音相关
  const [recording, setRecording] = useState(false);
  const [recordMode, setRecordMode] = useState(null);
  const recorderRef = useRef(null);
  const audioRef = useRef(null);

  // 统一管理语音识别 WebSocket（复用连接，避免重复 new WebSocket）
  const latestASRResult = useRef(""); // 存储最新的语音识别结果

  function ensureWS() {
    if (audioRef.current && audioRef.current.readyState === WebSocket.OPEN) {
      return audioRef.current;
    }
    ß;
    const ws = new WebSocket(API.audioSocket);

    ws.onmessage = (event) => {
      console.log(event.data, "返回的录音信息");
      if (event.data === "pong" || event.data === "ping") return;
      try {
        const obj = event.data ? JSON.parse(event.data) : {};
        const msg = obj?.message || "";
        latestASRResult.current = msg; // 更新最新结果

        // 如果是实时模式，立即更新UI
        if (!window.isFullTime) {
          chatBoxRef.current?.senderBox.setContent(msg);
        }
      } catch {}
    };

    ws.onerror = (e) => {
      console.error("WebSocket 错误:", e);
      ws.close();
    };

    ws.onclose = () => {
      audioRef.current = null;
    };

    audioRef.current = ws;
    return ws;
  }

  //判断是否是钉钉环境
  function isDDing() {
    var userAgent = navigator.userAgent;
    const isDingTalk = userAgent.indexOf("DingTalk") > -1;
    return isDingTalk;
  }

  // 检查钉钉 JSAPI 是否可用
  const checkDingTalkAPI = () => {
    if (typeof dd === "undefined" || !dd.device || !dd.device.audio) {
      throw new Error("钉钉 JSAPI 未加载或不可用，请确保在钉钉 App 内打开");
    }
  };

  //钉钉录音
  //开始录音
  const startDingTalkRecording = () => {
    return new Promise((resolve, reject) => {
      // 设置超时，防止一直等待
      const timer = setTimeout(() => {
        reject(new Error("钉钉录音启动超时，请检查权限或网络"));
      }, 5000);

      try {
        checkDingTalkAPI();

        const onSuccess = () => {
          clearTimeout(timer);
          console.log("钉钉开始录音");
          resolve();
        };

        const onFail = (err) => {
          clearTimeout(timer);
          console.error("钉钉录音失败", err);
          reject(new Error("钉钉录音失败: " + JSON.stringify(err)));
        };

        // 确保钉钉 JSAPI 已初始化
        if (dd && typeof dd.ready === "function") {
          dd.ready(() => {
            dd.device.audio.startRecord({
              success: onSuccess,
              fail: onFail,
            });
          });
          // 捕获钉钉鉴权错误
          if (typeof dd.error === "function") {
            dd.error((err) => {
              clearTimeout(timer);
              console.error("钉钉鉴权失败", err);
              // 鉴权失败不一定影响录音（取决于API），但最好记录
            });
          }
        } else {
          // 如果 dd.ready 不存在，直接调用（钉钉 App 内可能已自动初始化）
          dd.device.audio.startRecord({
            success: onSuccess,
            fail: onFail,
          });
        }
      } catch (error) {
        clearTimeout(timer);
        reject(error);
      }
    });
  };
  //结束录音
  const stopDingTalkRecording = async () => {
    return new Promise((resolve, reject) => {
      try {
        checkDingTalkAPI();
        dd.device.audio.stopRecord({
          success: (res) => {
            //mediaId 是钉钉音频文件标识
            resolve(res.mediaId);
          },
          fail: (err) => {
            reject(new Error("钉钉停止录音失败: " + JSON.stringify(err)));
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };
  //下载钉钉音频
  const downloadDingTalkAudio = async (mediaId) => {
    return new Promise((resolve, reject) => {
      try {
        checkDingTalkAPI();
        dd.device.audio.download({
          mediaId: mediaId,
          onSuccess: function (res) {
            resolve(res.localAudioId);
          },
          onFail: function (err) {
            reject(new Error("钉钉下载音频失败: " + JSON.stringify(err)));
          },
        });
      } catch (error) {
        reject(error);
      }
    });
  };

  const startRecording = async () => {
    const ws = ensureWS();
    const startWithStream = async () => {
      let stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
        type: "audio",
        mimeType: "audio/webm",
        recorderType: RecordRTC.StereoAudioRecorder,
        timeSlice: 400,
        desiredSampRate: 16000,
        numberOfAudioChannels: 1,
        disableLogs: false,
        ondataavailable: async (blob) => {
          if (window.isAly) {
            const aliyunBlob = await convertBlobToPCM(blob);
            console.log("转换后Blob大小:", aliyunBlob, aliyunBlob.size, "字节");
            ws.send(aliyunBlob);
          } else {
            console.log("aaa");
            ws.send(blob);
          }
        },
      });
      await recorder.startRecording();
      recorderRef.current = recorder;
      audioRef.current = ws;
      setRecording(true);
    };

    if (ws.readyState === WebSocket.OPEN) {
      await startWithStream();
    } else {
      ws.onopen = async () => {
        console.log("音频 WebSocket 链接成功");
        await startWithStream();
      };
    }
  };

  // const startRecording = async () => {
  //   const ws = new WebSocket(API.audioSocket);
  //   ws.onmessage = (data) => {
  //     console.log(data, "返回的录音信息");
  //     if (data === "pong" || data === "ping") {
  //       return;
  //     }
  //     try {
  //       const obj = data && data.data ? JSON.parse(data?.data) : {};
  //       chatBoxRef.current?.senderBox.setContent(obj?.message || "");
  //     } catch {}
  //   };
  //   // 新增错误和关闭监听
  //   ws.onerror = (error) => {
  //     console.error("WebSocket 错误:", error);
  //     ws.close(); // 异常时强制关闭
  //   };
  //   ws.onclose = (event) => {
  //     console.log(`连接已关闭，状态码：${event.code}，原因：${event.reason}`);
  //   };
  //   ws.onopen = async () => {
  //     console.log("链接成功");
  //     let stream = await navigator.mediaDevices.getUserMedia({
  //       audio: true,
  //       video: false,
  //     });
  //     const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
  //       type: "audio",
  //       mimeType: "audio/webm",
  //       recorderType: RecordRTC.StereoAudioRecorder,
  //       timeSlice: 400,
  //       desiredSampRate: 16000,
  //       numberOfAudioChannels: 1,
  //       disableLogs: false,
  //       ondataavailable: async (blob) => {
  //         // const arrayBuffer = await blob.arrayBuffer();
  //         if (window.isAly) {
  //           const aliyunBlob = await convertBlobToPCM(blob);
  //           console.log("转换后Blob大小:", aliyunBlob, aliyunBlob.size, "字节");
  //           ws.send(aliyunBlob);
  //         } else {
  //           ws.send(blob);
  //         }
  //       },
  //     });
  //     recorder.startRecording();
  //     recorderRef.current = recorder;
  //     audioRef.current = ws;
  //     setRecording(true);
  //   };
  // };

  const audioContextRef = useRef(null);

  useEffect(() => {
    try {
      audioContextRef.current = new (window.AudioContext ||
        window.webkitAudioContext)({
        sampleRate: 16000,
      });
    } catch (err) {
      // setError('初始化音频上下文失败: ' + err.message);
    }
  }, []);

  //停止录音
  const stopRecording = () => {
    if (recorderRef.current && audioRef.current) {
      const recorder = recorderRef.current;
      const ws = audioRef.current;
      console.log(audioRef, recorder, "这是啥");
      recorder.stopRecording();
      setTimeout(() => {
        // 检查 WebSocket 状态再操作
        if (ws.readyState === WebSocket.OPEN) {
          try {
            // 发送明确的结束指令到服务器（如 "{type: 'stop'}"）
            if (window.isAly) {
              ws.send(new Uint8Array(0));
            } else {
              ws.send("");
            }

            // 非实时模式下，在结束时将最终结果填入输入框
            if (window.isFullTime) {
              console.log(
                "非实时模式，填入最终识别结果:",
                latestASRResult.current
              );
              // chatBoxRef.current?.senderBox.setContent(latestASRResult.current);
              const text = latestASRResult.current;
              if (text) {
                if (typeof chatBoxProps?.onSubmit === "function") {
                  chatBoxProps.onSubmit(ctx, text);
                } else {
                  StartChat(text);
                }
              }
            }

            ws.close(1000, "这是关闭");
            console.log("WebSocket 关闭成功");
          } catch (error) {
            console.error("关闭 WebSocket 失败:", error);
          }
        } else {
        }
        // 清理引用
        audioRef.current = null;
        recorderRef.current = null;
        setRecording(false);
      }, 1000);

      // recorderRef.current.stopRecording(() => {
      //     setTimeout(() => {
      //         audioRef.current?.send('');
      //         audioRef.current?.close();
      //     }, 1000)

      //     setRecording(false);
      // });
    }
  };

  // 兼容钉钉的 Toast
  const showToast = (content, type = "info") => {
    if (
      isDDing() &&
      dd &&
      dd.device &&
      dd.device.notification &&
      dd.device.notification.toast
    ) {
      let icon = "success";
      if (type === "error") icon = "error";
      if (type === "warning") icon = "";
      dd.device.notification.toast({
        icon: icon,
        text: content,
        duration: 2.1,
        delay: 0,
        onSuccess: function (result) {},
        onFail: function (err) {},
      });
    } else {
      message[type](content);
    }
  };

  // 兼容钉钉的 Loading
  const showLoading = (content) => {
    if (
      isDDing() &&
      dd &&
      dd.device &&
      dd.device.notification &&
      dd.device.notification.showPreloader
    ) {
      dd.device.notification.showPreloader({
        text: content,
        showIcon: true,
        onSuccess: function (result) {},
        onFail: function (err) {},
      });
      return () =>
        dd.device.notification.hidePreloader({
          onSuccess: function (result) {},
          onFail: function (err) {},
        });
    } else {
      return message.loading(content, 0);
    }
  };

  const sendBlobToWebSocket = async (blob) => {
    const hideLoading = showLoading("正在识别中...");
    try {
      const ws = ensureWS();
      // 确保连接已打开
      if (ws.readyState !== WebSocket.OPEN) {
        await new Promise((resolve, reject) => {
          ws.onopen = () => resolve();
          ws.onerror = (e) => reject(e);
          // 如果已经是 CONNECTING 状态，onopen 会被触发
        });
      }
      console.log("发送Blob到WebSocket, 大小:", blob.size);
      latestASRResult.current = ""; // 清空上一次的结果
      let dataToSend;
      let size;
      if (window.isAly) {
        dataToSend = await convertBlobToPCM(blob);
        size = dataToSend.byteLength;
      } else {
        dataToSend = blob;
        size = dataToSend.size;
      }

      // 模拟流式传输
      const chunkSize = 4096; // 4KB
      let offset = 0;
      while (offset < size) {
        const end = Math.min(offset + chunkSize, size);
        const chunk = dataToSend.slice(offset, end);
        ws.send(chunk);
        offset = end;
        // 小延时，避免发送太快导致服务端处理不过来
        await new Promise((r) => setTimeout(r, 20));
      }

      // 发送结束信号
      if (window.isAly) {
        ws.send(new Uint8Array(0));
      } else {
        ws.send("");
      }

      // 等待识别结果
      await new Promise((resolve) => {
        setTimeout(() => {
          const text = latestASRResult.current;
          console.log("WebSocket 识别结果:", text);
          hideLoading();
          if (text) {
            if (typeof chatBoxProps?.onSubmit === "function") {
              chatBoxProps.onSubmit(ctx, text);
            } else {
              StartChat(text);
            }
          } else {
            showToast("未识别到文字", "warning");
          }

          // 识别完成后关闭连接，与 stopRecording 保持一致
          ws.close();
          resolve();
        }, 1000);
      });
    } catch (err) {
      console.error("WebSocket 发送失败", err);
      hideLoading();
      showToast("语音识别失败，请稍后重试", "error");
    }
  };

  //开始录音(统一入口)
  const startAudio = async () => {
    if (recording) {
      return;
    }
    const isFullTime = window.isFullTime;
    const isDDing = false;
    console.log(
      "开始录音, 环境:",
      isDDing ? "钉钉" : "浏览器",
      "模式:",
      !isFullTime ? "实时" : "非实时"
    );

    try {
      if (isDDing) {
        if (!isFullTime) {
          await startRecording();
        } else {
          await startDingTalkRecording();
          setRecordMode("dingtalk-once");
          setRecording(true);
        }
      } else {
        if (!isFullTime) {
          await startRecording();
        } else {
          console.log("开始录音(非实时)");
          const stream = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false,
          });
          const recorder = new RecordRTC.RecordRTCPromisesHandler(stream, {
            type: "audio",
            mimeType: "audio/webm",
            recorderType: RecordRTC.StereoAudioRecorder,
            desiredSampRate: 16000,
            numberOfAudioChannels: 1,
            disableLogs: false,
          });
          await recorder.startRecording();
          recorderRef.current = recorder;
          setRecordMode("browser-once");
          setRecording(true);
        }
      }
    } catch (e) {
      console.error("开始录音失败", e);
      message.error("开始录音失败: " + (e.message || "请检查麦克风权限"));
      setRecording(false);
      setRecordMode(null);
    }
  };
  console.log("recording==", recording);

  //结束录音(统一入口)
  async function localAudioIdToBlob(localAudioId) {
    try {
      // 尝试使用 XHR 获取 Blob，兼容性更好
      return await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", localAudioId, true);
        xhr.responseType = "blob";
        xhr.onload = function () {
          if (this.status === 200 || this.status === 0) {
            resolve(this.response);
          } else {
            reject(new Error("XHR failed status: " + this.status));
          }
        };
        xhr.onerror = function () {
          reject(new Error("XHR failed"));
        };
        xhr.send();
      });
    } catch (e) {
      console.warn("XHR failed, trying fetch", e);
      const res = await fetch(localAudioId);
      return await res.blob();
    }
  }
  const stopAudio = async () => {
    const isFullTime = window.isFullTime;
    console.log("结束录音, 模式:", isFullTime ? "实时" : "非实时");
    const isDDing = false;
    if (!isFullTime) {
      stopRecording();
    } else {
      console.log("结束录音(非实时)");
      if (!recording) {
        return;
      }
      try {
        let blob = null;
        if (recordMode === "dingtalk-once" || isDDing) {
          const mediaId = await stopDingTalkRecording();
          try {
            const localAudioId = await downloadDingTalkAudio(mediaId);
            blob = await localAudioIdToBlob(localAudioId);
          } catch (blobErr) {
            console.warn("获取音频Blob失败，尝试translateVoice", blobErr);
            if (
              dd &&
              dd.device &&
              dd.device.audio &&
              dd.device.audio.translateVoice
            ) {
              const hideLoading = showLoading("音频获取失败，尝试云端转译...");
              dd.device.audio.translateVoice({
                mediaId: mediaId,
                duration: 5.0,
                success: (res) => {
                  hideLoading();
                  if (res.content) {
                    if (typeof chatBoxProps?.onSubmit === "function") {
                      chatBoxProps.onSubmit(ctx, res.content);
                    } else {
                      StartChat(res.content);
                    }
                  } else {
                    showToast("未识别到文字", "warning");
                  }
                },
                fail: (err) => {
                  hideLoading();
                  showToast("转译失败: " + JSON.stringify(err), "error");
                },
              });
              setRecording(false);
              setRecordMode(null);
              return;
            }
            throw blobErr;
          }
        } else if (recordMode === "browser-once" || recorderRef.current) {
          const recorder = recorderRef.current;
          await recorder.stopRecording();
          blob = await recorder.getBlob();
        }
        recorderRef.current = null;
        setRecording(false);
        setRecordMode(null);
        if (!blob) {
          showToast("未能获取录音数据", "warning");
          return;
        }
        if (window.useFullAudio2Text) {
          const hideLoading = showLoading("正在识别中...");
          try {
            const file = new File([blob], "recording.webm", {
              type: "audio/webm",
              lastModified: Date.now(),
            });
            const zntId = initData?.data?.id;
            const res = await runGetAudio2Text(zntId, file);
            const text = res?.data?.text;
            hideLoading();
            if (text) {
              if (typeof chatBoxProps?.onSubmit === "function") {
                chatBoxProps.onSubmit(ctx, text);
              } else {
                StartChat(text);
              }
            } else {
              showToast("未识别到文字", "warning");
            }
          } catch (err) {
            hideLoading();
            console.error("audio2text 调用失败", err);
            showToast("语音识别失败，请稍后重试", "error");
          }
        } else {
          await sendBlobToWebSocket(blob);
        }
      } catch (e) {
        console.error("结束录音或识别失败", e);
        showToast("结束录音失败: " + (e.message || "未知错误"), "error");
        setRecording(false);
        setRecordMode(null);
      }
    }
  };

  const cancelRecording = async () => {
    console.log("取消录音");
    const isDDing = false;
    if (!recording) return;
    try {
      if (recordMode === "dingtalk-once" || isDDing) {
        await stopDingTalkRecording();
      } else if (recordMode === "browser-once" || recorderRef.current) {
        await recorderRef.current.stopRecording();
      }
    } catch (e) {
      console.error("取消录音失败", e);
    }
    recorderRef.current = null;
    setRecording(false);
    setRecordMode(null);
  };

  // 核心函数：将Blob转换为PCM数据
  const convertBlobToPCM = (blob) => {
    return new Promise((resolve, reject) => {
      if (!audioContextRef.current) {
        reject(new Error("音频上下文未初始化"));
        return;
      }

      const fileReader = new FileReader();

      fileReader.onload = () => {
        // 解码音频数据
        audioContextRef.current.decodeAudioData(
          fileReader.result,
          (audioBuffer) => {
            console.log("解码后信息:", {
              length: audioBuffer.length,
              sampleRate: audioBuffer.sampleRate,
              channels: audioBuffer.numberOfChannels,
            });

            // 如果采样率不是16000，重采样
            if (audioBuffer.sampleRate !== 16000) {
              const offlineContext = new OfflineAudioContext(
                1, // 单声道
                Math.ceil(
                  (audioBuffer.length * 16000) / audioBuffer.sampleRate
                ),
                16000
              );

              const source = offlineContext.createBufferSource();
              source.buffer = audioBuffer;
              source.connect(offlineContext.destination);
              source.start(0);

              offlineContext
                .startRendering()
                .then((renderedBuffer) => {
                  const pcm = float32ToInt16(renderedBuffer.getChannelData(0));
                  resolve(pcm.buffer);
                })
                .catch(reject);
            } else {
              // 确保单声道
              let channelData;
              if (audioBuffer.numberOfChannels > 1) {
                // 合并声道为单声道
                const left = audioBuffer.getChannelData(0);
                const right = audioBuffer.getChannelData(1);
                channelData = new Float32Array(left.length);
                for (let i = 0; i < left.length; i++) {
                  channelData[i] = (left[i] + right[i]) / 2;
                }
              } else {
                channelData = audioBuffer.getChannelData(0);
              }

              // 转换为16位整数PCM
              const pcm = float32ToInt16(channelData);
              resolve(pcm.buffer);
            }
          },
          reject
        );
      };

      fileReader.onerror = () => reject(fileReader.error);
      fileReader.readAsArrayBuffer(blob);
    });
  };

  // 将Float32音频数据转换为Int16 PCM
  const float32ToInt16 = (input) => {
    const output = new Int16Array(input.length);
    for (let i = 0; i < input.length; i++) {
      // 音频数据范围是[-1, 1]，转换为16位整数范围[-32768, 32767]
      const value = Math.max(-1, Math.min(1, input[i]));
      output[i] = value < 0 ? value * 0x8000 : value * 0x7fff;
    }
    return output;
  };

  //上传图片相关
  const [fileOpen, setFileOpen] = useState(false);
  const attachmentsRef = useRef(null);
  const [fileList, setFileList] = useState([]);
  const picRef = useRef();
  const fileRef = useRef();
  const fileAndImgRef = useRef();

  //文件和图片上传相关
  const header = fileOpen ? (
    <div
      style={{
        minHeight: "120px",
        background: "#fff",
        borderRadius: "12px",
        position: "relative",
      }}
      className="headerFile"
    >
      <div
        style={{
          textAlign: "right",
          position: "absolute",
          right: "10px",
          top: "10px",
          zIndex: "99",
        }}
      >
        <CloseOutlined
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            setFileOpen(false);
            setFileList([]);
          }}
        />
      </div>
      <Attachments
        overflow="scrollX"
        ref={attachmentsRef}
        items={fileList}
        multiple={true}
        accept={
          initData?.data?.enabledfileupload * 1 === 1 &&
          initData?.data?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png,.csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : initData?.data?.enabledimgupload * 1 === 1
            ? ".jpg,.jpeg,.png"
            : initData?.data?.enabledfileupload * 1 === 1
            ? ".csv,.md,application/pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
            : ""
        }
        maxCount={
          initData?.data?.enabledfileupload * 1 === 1 &&
          initData?.data?.enabledimgupload * 1 === 1
            ? initData?.data?.fileuploadcount * 1 +
              initData?.data?.imguploadcount * 1
            : initData?.data?.enabledfileupload * 1 === 1
            ? initData?.data?.fileuploadcount * 1
            : initData?.data?.enabledimgupload * 1 === 1
            ? initData?.data?.imguploadcount * 1
            : undefined
        }
        beforeUpload={(file) => {
          let uploadTypes = [];
          if (
            initData?.data?.enabledfileupload * 1 === 1 &&
            initData?.data?.enabledimgupload * 1 === 1
          ) {
            uploadTypes = [
              "image/jpeg",
              "image/png",
              "image/gif",
              "image/bmp",
              "application/pdf",
              "application/msword", // .doc
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
              "application/vnd.ms-powerpoint", // .ppt
              "application/vnd.ms-excel", // .xls
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
              "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
              "text/markdown", // .md
              "text/csv", // .csv
              "text/plain", // 兼容扩展名检查
            ];
          } else {
            if (initData?.data?.enabledfileupload * 1 === 1) {
              uploadTypes = uploadTypes = [
                "application/pdf",
                "application/msword", // .doc
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
                "application/vnd.ms-powerpoint", // .ppt
                "application/vnd.ms-excel", // .xls
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
                "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
                "text/markdown", // .md
                "text/csv", // .csv
                "text/plain", // 兼容扩展名检查
              ];
            }

            if (initData?.data?.enabledimgupload * 1 === 1) {
              uploadTypes = [
                "image/jpeg",
                "image/png",
                "image/gif",
                "image/bmp",
              ];
            }
          }

          const newCount = fileList.length + 1; // 当前已选 + 待上传
          if (
            initData?.data?.enabledfileupload * 1 === 1 &&
            initData?.data?.enabledimgupload * 1 === 1
          ) {
            const imageCount = fileList.filter(
              (file) => file.type === "image"
            ).length;
            const fileCount = fileList.filter(
              (file) => file.type === "document"
            ).length;
            if (imageCount >= initData?.data?.imguploadcount * 1) {
              message.warning(
                `最多只能上传${initData?.data?.imguploadcount * 1}张图片`
              );
              return false;
            }

            if (fileCount >= initData?.data?.fileuploadcount * 1) {
              message.warning(
                `最多只能上传${initData?.data?.fileuploadcount * 1}个附件`
              );
              return false;
            }

            if (
              newCount >
              initData?.data?.fileuploadcount * 1 +
                initData?.data?.imguploadcount * 1
            ) {
              message.warning(
                `最多只能上传${
                  initData?.data?.fileuploadcount * 1 +
                  initData?.data?.imguploadcount * 1
                }个附件`
              );
              return false;
            }
          } else {
            if (initData?.data?.enabledfileupload * 1 === 1) {
              if (newCount > initData?.data?.fileuploadcount * 1) {
                message.warning(
                  `最多只能上传${initData?.data?.fileuploadcount * 1}个附件`
                );
                return false;
              }
            }

            if (initData?.data?.enabledimgupload * 1 === 1) {
              if (newCount > initData?.data?.imguploadcount * 1) {
                message.warning(
                  `最多只能上传${initData?.data?.imguploadcount * 1}张图片`
                );
                return false;
              }
            }
          }

          const isAllowed =
            uploadTypes.includes(file.type) ||
            file.name.includes("md") ||
            file.name.includes("MD");

          // 获取文件扩展名
          const fileName = file.name;
          const extension = fileName
            .substring(fileName.lastIndexOf(".") + 1)
            .toLowerCase();

          // 设置不同文件类型的大小限制
          const isImage = ["jpg", "jpeg", "png"].includes(extension);
          const maxSize = isImage ? 30 * 1024 * 1024 : 100 * 1024 * 1024; // 图片30MB，其他文件100MB

          if (file.size > maxSize) {
            message.error(
              `${isImage ? "图片" : "文件"}大小不能超过${
                isImage ? "30MB" : "100MB"
              }`
            );
            return Upload.LIST_IGNORE;
          }

          if (!isAllowed) {
            message.error(
              "仅支持图片、文档、Markdown (.md) 和 CSV (.csv) 文件"
            );
            return Upload.LIST_IGNORE; // 阻止添加到文件列表
          }

          return true;
        }}
        onRemove={(file) => {
          const newFileList = fileList.filter((item) => item.uid !== file.uid);
          setFileList(fileList && fileList.length ? newFileList : []);
        }}
        customRequest={(val) => {
          const { file } = val;
          const formData = new FormData();
          formData.append("files", file);
          axios
            .post(API.uploadDocs, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              const data = res?.data?.result?.data || [];
              const arr = [];
              data.map((item) => {
                arr.push({
                  uid: item.uuid,
                  name: item.filename,
                  status: "done",
                  url:
                    window.location.origin +
                    API.askDownLoadDocs +
                    `/${item.uuid}.${item?.filename?.split(".")[1]}`,
                  type: item.type,
                  uuid: item.uuid,
                  size: file.size,
                });
              });
              setFileList([...fileList, ...arr]);
            });
        }}
        placeholder={(type) =>
          type === "drop"
            ? {
                title: "Drop file here",
              }
            : {
                icon: <CloudUploadOutlined />,
                title: "上传文件",
                description: "单击或拖动文件到此区域进行上传",
              }
        }
      ></Attachments>
    </div>
  ) : undefined;

  const { data: getSelectedZntData, runAsync: runGetSelectedZnt } =
    useBaseRequest(() => getSelectedZnt(), {
      manual: true,
      onSuccess: (res) => {
        console.log(res, "精选智能体");
      },
    });

  useEffect(() => {
    // runGetSelectedZnt()
  }, []);

  useEffect(() => {
    const str = decodeURIComponent(getUrlParam("question") || "");
    const question = JSON.parse(window.sessionStorage.getItem("question"));
    if (str) {
      if (initData?.data?.id) {
        setTimeout(() => {
          StartChat(str.toString());
        }, 5);
      }
    }
    if (question) {
      if (initData?.data?.id) {
        setTimeout(() => {
          StartChat(decodeURIComponent(question).toString());
        }, 5);
        window.sessionStorage.removeItem("question");
      }
    }
  }, [initData?.data?.id]);

  useEffect(() => {
    if (embed) {
      const str = decodeURIComponent(getUrlParam("meauType") || "");
      if (str) {
        setActiveMenu("brain");
      }
    }
  }, [embed]);

  useEffect(() => {
    if (window.urlParam) {
      const str = getUrlParam("active");
      const files = window.sessionStorage.getItem("files");
      console.log(files, "会话存储数据");
      if (files) {
        const data = JSON.parse(files);
        window.sessionStorage.removeItem("files");
        setFileList(data);
      }
      const skillId = window.sessionStorage.getItem("skillId");
      if (skillId) {
        setNewInputId(JSON.parse(skillId));
        window.sessionStorage.removeItem("skillId");
      }
      const newInputSubmitStr = window.sessionStorage.getItem("newInputSubmit");
      if (newInputSubmitStr) {
        setNewInputSubmit(JSON.parse(newInputSubmitStr));
        window.sessionStorage.removeItem("newInputSubmit");
      }
      if (str) {
        setActiveMenu("brain");
        setShowActiveMeau(false);
      }

      const selectedValueStr = window.sessionStorage.getItem("selectedValue");
      if (selectedValueStr) {
        setSelectedValue({
          key: JSON.parse(selectedValueStr)?.key,
        });
        setZdKnowledgeName(JSON.parse(selectedValueStr)?.name);
        window.sessionStorage.removeItem("selectedValue");
      }
    }
  }, []);

  //待办相关
  // useEffect(() => {
  //     axios.all([getMsg(), getNotice(), getHanding(), getSchedule()]).then(axios.spread((res, res1, res2, res3) => {
  //         console.log(res, res1, res2, res3, "待办相关")
  //     }))
  // }, [])

  // //消息
  // const getMsg = () => {
  //     return axios.get(window.msg)
  // }

  // //通知公告
  // const getNotice = () => {
  //     return axios.get(window.notice)
  // }

  // //待办
  // const getHanding = () => {
  //     return axios.get(window.handing)
  // }

  // //日程
  // const getSchedule = () => {
  //     return axios.get(window.schedule)
  // }

  useEffect(() => {
    if (fileOpen && attachmentsRef.current) {
      console.log("Attachments component mounted:", attachmentsRef.current);
    }
  }, [fileOpen]);

  const [innerUrl, setInnerUrl] = useState("");

  const [zskDisabled, setZskDisabled] = useState(false);

  useEffect(() => {
    window.onStartChat = (params) => {
      if (initData?.data?.id) {
        // setTimeout(() => {

        // }, 5);
        return StartChat(params.query, "", true, params);
      }
    };
  }, [initData?.data?.id]);

  useEffect(() => {
    console.log(receiving, items, "返回来的数据");

    const _items = items || [];
    window.changeAnswerContent = (content = "", id) => {
      if (_items && _items.length) {
        for (let i = 0; i < _items.length; i++) {
          console.log(_items[i], "每条数据");
          if (_items[i].qId && _items[i].qId !== undefined) {
            if (_items[i].qId === id) {
              // if (_items[i].content && _items[i].content !== undefined) {
              //   _items[i].content = content;
              //   if (
              //     _items[i].data.answer &&
              //     _items[i].data.answer !== undefined
              //   ) {
              //     //   _items[i].data.answer = content;
              //   }
              // }

              _items[i].content = content;

              if (_items[i].srcs && _items[i].srcs !== undefined) {
                delete _items[i].srcs;
              }
            }
          }
          // if(_items[i]?.qId === id){
          //   if(_items[i] && _items[i].data && _items[i].data.answer && _items[i].data.answer !== undefined)
          //   _items[i]?.data?.answer = content
          // }
        }
      }
      console.log(_items, "修改过后的items");

      setItems([..._items]);
    };
  }, [items]);

  useEffect(() => {
    window.name = "sudyaiqa";
  }, []);

  const ctx = useMemo(() => {
    return {
      chat: StartChat,
      changeAgent: swtichZnt,
      data: initData?.data,
      promptsItems,
      reloadHots: onReloadHots,
    };
  }, [StartChat, swtichZnt, initData?.data, promptsItems, onReloadHots]);

  //获取token使用量
  useEffect(() => {
    if (window.showToken) {
      runGetTokenConsumption();
    }
  }, []);

  const { data: getTokenConsumptionData, runAsync: runGetTokenConsumption } =
    useBaseRequest(() => getTokenConsumption(), {
      manual: true,
      onSuccess: (res) => {
        console.log(res, "输出的token使用量");
      },
    });

  //语音转文字
  const { data: audio2TextData, runAsync: runGetAudio2Text } = useBaseRequest(
    (zntId, file) => getAudio2Text(zntId, file),
    {
      manual: true,
      onSuccess: (res) => {
        console.log(res, "audio2text 接口返回");
      },
    }
  );

  const [showActiveMeau, setShowActiveMeau] = useState(false);
  const [tokenOpen, setTokenOpen] = useState(false);

  const [mxfwActiveTab, setMxfwActiveTab] = useState("");
  const [mxglActivetab, setMxglActiveTab] = useState("");
  const [poppoverOpen, setPoppoverOpen] = useState(false);
  const [changeContent, setChangeContent] = useState("");
  const [chooseZsk, setChooseZsk] = useState(false);

  return (
    <ChatContext.Provider value={ctx}>
      <ChatPortalLayout
        className={`${single ? (isMobile ? "agent" : "pcAgent") : ""}`}
        {...(typeof portalLayout === "object" ? portalLayout : {})}
        hide={!portalLayout}
        title={fixedName ? fixedName : agentName}
      >
        <Spin
          indicator={<LoadingOutlined spin />}
          spinning={loadingInitData && !initData?.data}
        >
          <ChatLayout
            title={
              newMode === "single" ? (
                initData?.data?.name
              ) : (
                <div>
                  <div>
                    <span
                      style={{
                        fontSize: window.beta ? "17px" : null,
                      }}
                    >
                      {window.backHome ? (
                        <span
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open("./", "_self");
                          }}
                        >
                          {initData?.data?.sysname}
                        </span>
                      ) : (
                        initData?.data?.sysname
                      )}
                      {/* {initData?.data?.sysname} */}
                    </span>
                    {window.beta ? (
                      <span style={window.betaStyle}>{window.betaText}</span>
                    ) : null}
                  </div>
                </div>
              )
            }
            user={
              initData?.data?.userId
                ? {
                    // 未登录，不显示登录信息
                    name: window.showToken ? (
                      <Popover
                        trigger="click"
                        placement="topRight"
                        arrow={false}
                        content={
                          <div
                            style={{
                              width: "220px",
                            }}
                          >
                            <div
                              style={{
                                padding: "20px 10px",
                                background: "#f5f5f5",
                                borderRadius: "10px",
                              }}
                            >
                              <img
                                style={{
                                  width: "40px",
                                  height: "40px",
                                }}
                                src={Mrtx}
                                alt=" "
                              />
                              <span
                                style={{
                                  padding: "0 10px",
                                  fontSize: "14px",
                                  color: "#222",
                                  fontWeight: "bold",
                                }}
                              >
                                {initData?.data?.userName ??
                                  initData?.data?.userId ??
                                  "未登录"}
                              </span>
                            </div>
                            <div>
                              <div
                                style={{
                                  padding: "10px 0",
                                }}
                              >
                                通用问答累计资源消耗：
                                {getTokenConsumptionData?.data?.qa?.[0]
                                  ?.used_quota || 0}
                              </div>
                              <div
                                style={{
                                  padding: "10px 0",
                                }}
                              >
                                通用问答当日资源消耗：
                                {getTokenConsumptionData?.data?.qa?.[0]
                                  ?.today_tokens || 0}
                              </div>
                              <div
                                style={{
                                  padding: "10px 0",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setActiveMenu("mxfw");
                                  setMxfwActiveTab("mxgl");
                                  setMxglActiveTab("mxlp");
                                }}
                              >
                                个人申请模型资源消耗{">>"}
                                {/* {getTokenConsumptionData?.data?.user?.[0]
                                  ?.used_quota || 0} */}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        <span>
                          {initData?.data?.userName ??
                            initData?.data?.userId ??
                            "未登录"}
                        </span>
                      </Popover>
                    ) : (
                      initData?.data?.userName ??
                      initData?.data?.userId ??
                      "未登录"
                    ),
                    id: initData?.data?.userId,
                    avatar: window.showToken ? (
                      <Popover
                        trigger="click"
                        placement="topRight"
                        arrow={false}
                        content={
                          <div
                            style={{
                              width: "220px",
                            }}
                          >
                            <div
                              style={{
                                padding: "20px 10px",
                                background: "#f5f5f5",
                                borderRadius: "10px",
                              }}
                            >
                              <img
                                style={{
                                  width: "40px",
                                  height: "40px",
                                }}
                                src={Mrtx}
                                alt=" "
                              />
                              <span
                                style={{
                                  padding: "0 10px",
                                  fontSize: "14px",
                                  color: "#222",
                                  fontWeight: "bold",
                                }}
                              >
                                {initData?.data?.userName ??
                                  initData?.data?.userId ??
                                  "未登录"}
                              </span>
                            </div>
                            <div>
                              <div
                                style={{
                                  padding: "10px 0",
                                }}
                              >
                                通用问答累计资源消耗：
                                {getTokenConsumptionData?.data?.qa?.[0]
                                  ?.used_quota || 0}
                              </div>
                              <div
                                style={{
                                  padding: "10px 0",
                                }}
                              >
                                通用问答当日资源消耗：
                                {getTokenConsumptionData?.data?.qa?.[0]
                                  ?.today_tokens || 0}
                              </div>
                              <div
                                style={{
                                  padding: "10px 0",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setActiveMenu("mxfw");
                                  setMxfwActiveTab("mxgl");
                                  setMxglActiveTab("mxlp");
                                }}
                              >
                                个人申请模型资源消耗{">>"}
                                {/* {getTokenConsumptionData?.data?.user?.[0]
                                  ?.used_quota || 0} */}
                              </div>
                            </div>
                          </div>
                        }
                      >
                        <img src={LoginIcon} />
                      </Popover>
                    ) : (
                      LoginIcon
                    ),
                    onClickLoginIcon: () => {},
                    extra: window.logoutUrl ? (
                      <>
                        <span
                          style={{
                            borderRadius: "20px",
                            border: "1px solid #DBE4EF",
                            display: "inline-block",
                            width: "30px",
                            height: "30px",
                            textAlign: "center",
                            lineHeight: "25px",
                          }}
                          onClick={() => {
                            window.location.href = window.logoutUrl;
                          }}
                        >
                          <img src={Logoff} alt=" " />
                        </span>
                      </>
                    ) : null,
                    onClickLoginName: () => {
                      console.log(123);
                      // setTokenOpen(true);
                    },
                  }
                : undefined
            }
            style={{
              visibility:
                loadingInitData && !initData?.data ? "hidden" : "visible",
            }}
            onClickCategory={(e, menu) => {
              console.log(menu, "点击侧边栏");
              if (menu.key === "chat") {
                swtichChat("", "");
                swtichZnt("");
              }
              if (menu.key === "hffk") {
                window.open(window.replyFeedbackUrl || "", "_blank");
              }
            }}
            onCategoryChange={(categoryKey, menu) => {
              setMxfwActiveTab("home");
              setMxglActiveTab("wdmx");
              handleTime();
              setHelpOpen(true);
              setShowActiveMeau(false);
              setReceiving(false);
              receivingRef.current = false;
              if (categoryKey === "hffk") {
                // setActiveMenu("chat");
              } else {
                setActiveMenu(categoryKey);
              }
              setNewRefresh(Math.random());
              setSkillName("");
              setNewInputId("");
              if (categoryKey === "chat" || categoryKey === "hffk") {
              } else {
                swtichChat("", "");
              }
            }}
            headerRight={
              mode == "conversation" && items.length ? (
                <HeaderRightRender
                  onNew={() => {
                    cancelHandler();
                    swtichChat("", znwdId);
                    setRefreshNew(znwdId);
                    handleTime();
                  }}
                  onHelp={(open) => {
                    setHelpOpen(typeof open === "boolean" ? open : (v) => !v);
                  }}
                  helpOpen={helpOpen}
                  helpPage={initData?.data?.helpPage}
                ></HeaderRightRender>
              ) : null
            }
            //帮助栏
            containerSider={
              <HelpDescription
                helpOpen={helpOpen}
                helpPage={initData?.data?.helpPage}
                onSearch={(a) => {
                  chatBoxRef.current?.senderBox?.insertContent(a);
                }}
                sysname={initData?.data?.name}
                zntId={initData?.data?.id}
                syslogo={initData?.data?.icon}
                syssummary={initData?.data?.summary}
                helpData={helpData}
              />
            }
            containerSiderProps={{
              collapsed: helpOpen,
              toggleRender: false,
              width: 285,
            }}
            categories={
              window.meaus && window.meaus.length > 0
                ? window.replyFeedback
                  ? [...categories, ...window.replyMeau, ...window.meaus]
                  : [...categories, ...window.meaus]
                : window.replyFeedback
                ? [...categories, ...window.replyMeau]
                : [...categories]
            }
            headerTitle={
              mode == "conversation" && items.length
                ? initData?.data?.name
                : undefined
            }
            hideCategories={!initData?.data?.searchUI ? ["search"] : []}
            footer={
              activeMenu === "chat" || showActiveMeau
                ? initData?.data?.friendlytips
                : ""
            }
            logo={
              newMode === "single"
                ? initData?.data?.icon
                : initData?.data?.syslogo
            }
            //aside={<HelpRender></HelpRender>}
            // headerRight={
            //   mode == "conversation" && items.length ? (
            //     <Popover content={"清除上下文"}>
            //       <Button type='text' icon={<ClearOutlined></ClearOutlined>}></Button>
            //     </Popover>
            //   ) : undefined
            // }
            className={
              mode === "conversation"
                ? `aling-chat-layout ${
                    window.meaus && window.meaus.length ? "zdpt" : ""
                  } ${`${window.zdShowHisSelect ? "hisSelect" : ""}`} ${`${
                    window.nblgStyle ? "nblgStyle" : ""
                  }`}`
                : `chatStyle ${
                    window.meaus && window.meaus.length ? "zdpt" : ""
                  } ${`${window.zdShowHisSelect ? "hisSelect" : ""}`} ${`${
                    window.nblgStyle ? "nblgStyle" : ""
                  }`}`
            }
            loadingCoversations={loadingInitData}
            onClickRecentExtraButton={(e) => {
              e.preventDefault();
              setActiveMenu("brain");
              setNewRefresh(Math.random());
              setSkillName("");
              setNewInputId("");
              swtichChat("", "");
              return false;
            }}
            category={activeMenu}
            conversationKey={
              activeMenu === "chat" && chatId?.current
                ? chatId?.current + ""
                : "-1"
            }
            getSiderToggleStyle={(c) => (c ? {} : { right: 10 })}
            header={mode == "conversation" && items.length ? true : false}
            {...others}
            isMobile={isMobile}
            // headerRight={
            //   mode == "conversation" && items.length ? (
            //     <HeaderRightRender
            //       onClear={() => {
            //         chatId.current &&
            //           runGetDeleteChat(chatId.current).then((res) => {
            //           })
            //         //setItems([])
            //         swtichZnt(SessionCache.current?.zntId)
            //         chatId.current = ""
            //       }}
            //     ></HeaderRightRender>
            //   ) : null
            // }
            mode={newMode}
            onConversationChange={(conversationKey, menu) => {
              console.log(conversationKey, menu, "点击历史的操作111");
              cancelHandler();
              handleTime();
              if (conversationKey !== "recent-dialog") {
                swtichChat(conversationKey, menu?.zntId ?? "");
              }
              setZnwtId(menu?.zntId ?? "");
              setSelectedKey(conversationKey);
              setHelpOpen(true);
              SessionCache.current = menu;
            }}
            historyKey={historyKey}
            onHistoryChange={onSendHistory}
            histories={getSessionListData?.data?.map((item) => ({
              key: item?.id,
              name: item?.title,
              timestamp: item?.updateTime,
            }))}
            coversations={
              newMode === "single"
                ? getSessionListData?.data?.map((his) => {
                    return {
                      key: his.id + "",
                      name: his.name,
                      recentMessage: his.query,
                    };
                  })
                : getSessionListData?.data?.map((his) => {
                    return {
                      key: his.id + "",
                      name: his.title,
                      icon: window.showDeafaultIcon ? DefultIcon : his.icon,
                      //recentMessage: his.title,
                      zntId: his.zntId,
                    };
                  })
            }
            coversationsAddOn={
              window.zdShowHisSelect ? (
                <div
                  style={{
                    width: "100%",
                  }}
                >
                  <Select
                    style={{
                      width: "100%",
                    }}
                    onChange={(val) => {
                      setHistorySearchId(val);
                    }}
                    value={historySearchId}
                    options={[
                      { label: "全部", value: "all" },
                      {
                        label: initDataRef?.current?.data?.name,
                        value: initDataRef?.current?.data?.id,
                      },
                    ].concat(
                      allZntList
                        ? allZntList?.data.map((item) => {
                            return {
                              label: item.name,
                              value: item.id,
                            };
                          })
                        : []
                    )}
                  />
                  {getSessionListData?.data &&
                  getSessionListData?.data.length ? null : (
                    <div
                      style={{
                        padding: "10px 0",
                        color: "#aaa",
                      }}
                    >
                      暂无记录，快去对话吧
                    </div>
                  )}
                </div>
              ) : null
            }
            defaultCollapsed={isMobile}
            historiesMenuProps={{
              actions: ["delete", "rename"],
              onClickAction(action, menu, index) {
                if (action === "rename") {
                  setRenameData(menu);
                  setReNameOpen(true);
                  return;
                }
                Modal.confirm({
                  title: "确定删除对话？",
                  content: "删除后，聊天记录将不可恢复。",
                  onOk: () => {
                    setDeleteKey(menu?.key || "");
                    runGetDeleteChat(menu?.key || "");
                  },
                });
              },
            }}
            coversationsMenuProps={{
              actions: ["delete", "rename"],
              hideActionsInMainMenu: true,
              onClickAction(action, menu, index) {
                if (action === "rename") {
                  setRenameData({ ...menu });
                  setReNameOpen(true);

                  return;
                }
                Modal.confirm({
                  title: "确定删除对话？",
                  content: "删除后，聊天记录将不可恢复。",
                  icon: "",
                  onOk: () => {
                    setDeleteKey(menu?.key || "");
                    runGetDeleteChat(menu?.key || "");
                  },
                });
              },
            }}
            {...(embed && embedOptions?.layout ? embedOptions?.layout : {})}
          >
            {activeMenu === "chat" ? (
              loadingInitData || (chatHistoryLoading && items.length === 0) ? (
                <Spin
                  size="large"
                  wrapperClassName="chat-loading"
                  indicator={<LoadingOutlined spin />}
                  spinning
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  ></div>
                </Spin>
              ) : (
                <>
                  <ChatBox
                    key={"key" + znwdId + newRefresh}
                    slotsInput={newSoltInput}
                    sending={sending || sendingRef.current}
                    // allowSpeech={
                    //   initData?.data?.enabledvinput
                    //     ? {
                    //         recording: recording,
                    //         onRecordingChange: (val) => {
                    //           console.log("val===", val);
                    //           if (val) {
                    //             startAudio();
                    //           } else {
                    //             stopAudio();
                    //           }
                    //           setRecording(val);
                    //         },
                    //       }
                    //     : undefined
                    // }
                    header={header}
                    //复制文件
                    onPasteFile={async (event, files) => {
                      if (
                        initData?.data?.enabledimgupload * 1 === 1 ||
                        initData?.data?.enabledfileupload * 1 === 1
                      ) {
                        setFileOpen(true);
                        setTimeout(() => {
                          if (
                            files &&
                            files.length > 0 &&
                            attachmentsRef.current?.upload
                          ) {
                            for (const file of files) {
                              try {
                                attachmentsRef.current.upload(file); // 异步处理
                              } catch (error) {
                                console.error("Error uploading file:", error);
                              }
                            }
                          }
                        }, 5);
                      } else {
                        return "";
                      }
                    }}
                    canSend={fileList && fileList.length > 0 ? true : undefined}
                    //文件上传
                    beforeSendActions={
                      <>
                        {initData?.data?.enabledvinput ? (
                          <>
                            {isMobile ? (
                              <>
                                {initData?.data?.vinputclientmode * 1 === 1 ||
                                initData?.data?.vinputclientmode * 1 === 3 ? (
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      if (recording) {
                                        stopAudio();
                                        setRecording(false);
                                      } else {
                                        startAudio();
                                      }
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                      src={
                                        recording ? AudioLoadingIcon : AudioIcon
                                      }
                                      alt={recording ? "结束录音" : "开始录音"}
                                    />
                                  </div>
                                ) : undefined}
                              </>
                            ) : (
                              <>
                                {initData?.data?.vinputclientmode * 1 === 1 ||
                                initData?.data?.vinputclientmode * 1 === 2 ? (
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    onClick={() => {
                                      if (recording) {
                                        stopAudio();
                                        setRecording(false);
                                      } else {
                                        startAudio();
                                      }
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                      }}
                                      src={
                                        recording ? AudioLoadingIcon : AudioIcon
                                      }
                                      alt={recording ? "结束录音" : "开始录音"}
                                    />
                                  </div>
                                ) : undefined}
                              </>
                            )}
                          </>
                        ) : null}

                        {initData?.data?.enabledimgupload * 1 === 1 &&
                        initData?.data?.enabledfileupload * 1 === 1 ? (
                          <>
                            <Tooltip
                              title={
                                <div>
                                  {`请上传图片或者文件（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式，最多上传${initData?.data?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、 XLSX、 XLS、 DOCX、 CSV、 MD格式）`}
                                </div>
                              }
                            >
                              <span
                                onClick={() => {
                                  fileAndImgRef?.current?.click();
                                }}
                              >
                                <img
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    cursor: "pointer",
                                  }}
                                  src={window.zdDisabledFj ? DisFj : Fj}
                                  alt=" "
                                />
                                {window.zdDisabledFj ? (
                                  ""
                                ) : (
                                  <input
                                    type="file"
                                    style={{
                                      display: "none",
                                    }}
                                    ref={fileAndImgRef}
                                    onClick={() => {
                                      setTimeout(() => {
                                        setFileOpen(true);
                                      }, 3);
                                    }}
                                    onChange={(a) => {
                                      if (window.zdDisabledFj) {
                                      } else {
                                        setTimeout(() => {
                                          if (
                                            a.target.files &&
                                            a.target.files.length > 0 &&
                                            attachmentsRef.current?.upload
                                          ) {
                                            for (const file of a.target.files) {
                                              try {
                                                attachmentsRef.current.upload(
                                                  file
                                                ); // 异步处理
                                              } catch (error) {
                                                console.error(
                                                  "Error uploading file:",
                                                  error
                                                );
                                              }
                                            }
                                          } else {
                                          }
                                        }, 5);
                                      }
                                    }}
                                  />
                                )}
                              </span>
                            </Tooltip>
                          </>
                        ) : (
                          <>
                            {initData?.data?.enabledimgupload * 1 === 1 ? (
                              <Tooltip
                                title={`${
                                  initData?.data?.enabledimgupload * 1 === 1 &&
                                  initData?.data?.enabledfileupload * 1 === 1
                                    ? "请上传图片或者文件"
                                    : initData?.data?.enabledimgupload * 1 === 1
                                    ? `请上传图片（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式`
                                    : ""
                                }`}
                              >
                                <span
                                  onClick={() => {
                                    picRef?.current?.click();
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      cursor: "pointer",
                                    }}
                                    src={Fj}
                                    alt=" "
                                  />
                                  <input
                                    type="file"
                                    style={{
                                      display: "none",
                                    }}
                                    ref={picRef}
                                    onChange={(a) => {
                                      setFileOpen(true);
                                      setTimeout(() => {
                                        if (
                                          a.target.files &&
                                          a.target.files.length > 0 &&
                                          attachmentsRef.current?.upload
                                        ) {
                                          for (const file of a.target.files) {
                                            try {
                                              attachmentsRef.current.upload(
                                                file
                                              ); // 异步处理
                                            } catch (error) {
                                              console.error(
                                                "Error uploading file:",
                                                error
                                              );
                                            }
                                          }
                                        }
                                      }, 5);
                                    }}
                                  />
                                </span>{" "}
                              </Tooltip>
                            ) : undefined}

                            {initData?.data?.enabledfileupload * 1 === 1 ? (
                              <Tooltip
                                title={
                                  <div>{`${
                                    initData?.data?.enabledimgupload * 1 ===
                                      1 &&
                                    initData?.data?.enabledfileupload * 1 === 1
                                      ? "请上传图片或者文件"
                                      : initData?.data?.enabledfileupload *
                                          1 ===
                                        1
                                      ? `请上传文件，最多上传${initData?.data?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、XLSX、XLS、DOCX、CSV、MD格式`
                                      : ""
                                  }`}</div>
                                }
                              >
                                <span
                                  onClick={() => {
                                    fileRef?.current?.click();
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      cursor: "pointer",
                                    }}
                                    src={Fj}
                                    alt=" "
                                  />
                                  <input
                                    type="file"
                                    style={{
                                      display: "none",
                                    }}
                                    ref={fileRef}
                                    onChange={(a) => {
                                      setFileOpen(true);
                                      setTimeout(() => {
                                        if (
                                          a.target.files &&
                                          a.target.files.length > 0 &&
                                          attachmentsRef.current?.upload
                                        ) {
                                          for (const file of a.target.files) {
                                            try {
                                              attachmentsRef.current.upload(
                                                file
                                              ); // 异步处理
                                            } catch (error) {
                                              console.error(
                                                "Error uploading file:",
                                                error
                                              );
                                            }
                                          }
                                        }
                                      }, 5);
                                    }}
                                  />
                                </span>
                              </Tooltip>
                            ) : undefined}
                          </>
                        )}
                      </>
                    }
                    autoLink={true}
                    actions={[
                      //initData?.data?.llmselectenabled  是否开启  1是0否 llmlist 模型列表
                      initData?.data?.llmselectenabled === 1 ? (
                        initData?.data?.llmlist ? (
                          <div className="dropDown" key={"moreModel"}>
                            <Dropdown
                              trigger={["click"]}
                              arrow={true}
                              menu={{
                                items: moreModel,
                                selectable: true,
                                selectedKeys: [selectedModelValue.key],
                                onClick: ({ key }) => {
                                  const selected = moreModel.find(
                                    (item) => item.key === key
                                  );
                                  if (selected) {
                                    setSelectedModelValue({
                                      key,
                                      label: selected?.label,
                                    });
                                  }
                                },
                              }}
                            >
                              <ChatActionButton key={"moreModelList"}>
                                {selectedModelValue.label}
                                <DownOutlined
                                  style={{
                                    fontSize: 12,
                                    color: "rgba(0, 0, 0, 0.45)",
                                    transition: "transform 0.2s",
                                  }}
                                />
                              </ChatActionButton>
                            </Dropdown>
                          </div>
                        ) : null
                      ) : null,
                      window.nblgShowZntSelect ? (
                        <>
                          {znwdId ? null : (
                            <>
                              <div
                                style={{
                                  width: "100%",
                                }}
                              >
                                <Select
                                  style={{
                                    minWidth: "150px",
                                  }}
                                  onChange={(val, item) => {
                                    if (item?.outerznt) {
                                      window.open(item?.outerurl);
                                    } else {
                                      swtichZnt(val);
                                    }
                                  }}
                                  value={initData?.data?.id}
                                  options={selectData}
                                />
                              </div>
                            </>
                          )}
                        </>
                      ) : null,
                      window.ShowZsk ? (
                        initData?.data?.zskList &&
                        initData?.data?.zskList.length > 0 ? (
                          initData?.data?.zskList.length > 1 ? (
                            <div
                              key={"dropDown"}
                              className="dropDown"
                              style={{
                                position: "relative",
                              }}
                            >
                              {window.zskSwitch ? (
                                <>
                                  <div
                                    className="switch"
                                    style={{
                                      position: "absolute",
                                      bottom: "7px",
                                      right: "5px",
                                      zIndex: 10,
                                    }}
                                  >
                                    <Switch
                                      className="custom-switch"
                                      value={zskDisabled}
                                      onChange={(val) => {
                                        console.log(val, "知识库禁用");
                                        setZskDisabled(val);
                                      }}
                                    />
                                  </div>
                                </>
                              ) : null}

                              <Space>
                                <Space.Compact>
                                  <Dropdown
                                    trigger={["click"]}
                                    arrow={false}
                                    disabled={zskDisabled}
                                    menu={{
                                      items: zskData,
                                      selectable: true,
                                      selectedKeys: [selectedValue?.key],
                                      onClick: ({ key }) => {
                                        const selected = zskData.find(
                                          (item) => item.key === key
                                        );
                                        if (selected) {
                                          setSelectedValue({
                                            key,
                                            label: selected?.label,
                                          });
                                        }
                                      },
                                    }}
                                    key={"zskList"}
                                  >
                                    <ChatActionButton key={"zskList"}>
                                      {selectedValue?.key === "all"
                                        ? selectedValue?.label
                                        : selectedValue?.label.length > 4
                                        ? selectedValue?.label.substring(0, 4) +
                                          "..."
                                        : selectedValue?.label}
                                      {window.zskSwitch ? (
                                        <>
                                          <div
                                            style={{
                                              width: "35px",
                                            }}
                                          ></div>
                                        </>
                                      ) : (
                                        <>
                                          <DownOutlined
                                            style={{
                                              fontSize: 12,
                                              color: "rgba(0, 0, 0, 0.45)",
                                              transition: "transform 0.2s",
                                            }}
                                          />
                                        </>
                                      )}
                                    </ChatActionButton>
                                  </Dropdown>
                                </Space.Compact>
                              </Space>
                            </div>
                          ) : null
                        ) : null
                      ) : null,

                      //initData?.data?.zskList  这是根据后端返回的zskList，做的下拉

                      window.showThinking ? (
                        initData?.data?.thinking === false || skillsName ? (
                          <>
                            {chooseZsk ? (
                              <ChatThinkActionButton
                                noTitle={false}
                                key={"deepthink"}
                                checkable
                                value={deepthink}
                                onChange={setDeepthink}
                              >
                                {isMobile ? "" : "深度思考"}
                              </ChatThinkActionButton>
                            ) : null}
                          </>
                        ) : (
                          <>
                            <ChatThinkActionButton
                              noTitle={false}
                              key={"deepthink"}
                              checkable
                              value={deepthink}
                              onChange={setDeepthink}
                            >
                              {isMobile ? "" : "深度思考"}
                            </ChatThinkActionButton>
                            {/* {window.zdZsk ? (
                              zdKnowledgeName ? (
                                <>
                                  <ChatActionButton>
                                    <span>{zdKnowledgeName}</span>
                                    <CloseOutlined
                                      onClick={() => {
                                        setZdKnowledgeName("");
                                        setSelectedValue({ key: "" });
                                      }}
                                    />
                                  </ChatActionButton>
                                </>
                              ) : (
                                <ChatActionButton
                                  onClick={() => {
                                    setZdKnowledgeOpen(true);
                                  }}
                                >
                                  {"请选择知识库"}
                                </ChatActionButton>
                              )
                            ) : null} */}
                          </>
                        )
                      ) : null,

                      initData?.data?.portalSearch ? (
                        <ChatPortalActionButton
                          key={"portalsearch"}
                          checkable
                          value={portalSearch}
                          onChange={setPortalSearch}
                        >
                          {isMobile ? "" : "门户搜索"}
                        </ChatPortalActionButton>
                      ) : null,
                      initData?.data?.siteSearch ? (
                        <ChatSiteActionButton
                          key={"sitesearch"}
                          checkable
                          value={siteSearch}
                          onChange={setSiteSearch}
                        >
                          {isMobile ? "" : "站群搜索"}
                        </ChatSiteActionButton>
                      ) : null,
                      initData?.data?.internetSearch ? (
                        <ChatInternetActionButton
                          key={"internetserarch"}
                          checkable
                          value={internetSearch}
                          onChange={setInternetSearch}
                        >
                          {isMobile ? "" : "联网搜索"}
                        </ChatInternetActionButton>
                      ) : null,
                    ]}
                    onClickItemPrompt={({ title }) => {
                      StartChat(title?.toString() ?? "");
                    }}
                    // emboed模式下，输入框前缀图标
                    prefixIcon={
                      embed && embedOptions?.sendBoxPrefixIcon !== false
                        ? embedOptions?.sendBoxPrefixIcon || true
                        : undefined
                    }
                    // renderAfterWelcome={
                    //     <ChatBoxItem gap={24} >

                    //         {/* <ChatPromptsCard title="猜你想问" items={initData?.data?.hotqas?.map(hot => ({ title: hot.name || hot.title || hot.text }))} /> */}
                    //         <div style={{ display: isMobile ? "unset" : "flex", gap: 24 }}>
                    //             <ChatTabsCard className="newQuestion" style={{ flex: "auto", height: "300px" }} items={[
                    //                 {
                    //                     label: "猜你想问",
                    //                     children: <div style={{
                    //                         height: "100%",
                    //                         overflow: "auto"
                    //                     }}>
                    //                         <ChatBubblePrompts column={3} arrowType='swapright' gap={[16, 24]} {...embedOptions?.promptsProps} onItemClick={info => StartChat(info.data.title?.toString())} style={{ maxWidth: 900, margin: '0 auto' }} block type='primary' items={(embedOptions?.prompts || initData?.data?.hotqas)?.map(hot => ({ title: hot.name || hot.title || hot.text }))} />
                    //                     </div>,
                    //                     key: "question"
                    //                 },
                    //                 {
                    //                     label: "测试123",
                    //                     children: <>123</>,
                    //                     key: "tab1"
                    //                 },
                    //                 {
                    //                     label: "测试456",
                    //                     children: <>456</>,
                    //                     key: "tab2"
                    //                 }
                    //             ]} />
                    //             <ChatAgentCube title="精选智能体" slide items={[{
                    //                 name: "图书管助手",
                    //                 description: "任何图书馆相关话题，都可以跟我聊聊"
                    //             }]} />
                    //         </div>

                    //     </ChatBoxItem>

                    // }
                    chatListProps={{
                      // onScrollTop(top) {
                      //   return handleRollLoading()
                      // },
                      emptyHolder: isDefaultAgent ? (
                        embed && !embedOptions?.showDefaultWelcome ? (
                          <ChatBoxItem
                            className={`${embed ? "embedContent" : ""} `}
                          >
                            <ChatWelcome
                              icon={initData?.data?.icon}
                              content={initData?.data?.summary}
                              title={initData?.data?.name}
                              layout="horizontal"
                              size="small"
                              footer={
                                alllength && alllength > 2 ? (
                                  <>
                                    <div
                                      style={{
                                        maxWidth: "900px",
                                        maxHeight: "300px",
                                        height: "300px",
                                      }}
                                    >
                                      <Tabs
                                        className="hotTab"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        activeKey={activeTab}
                                        onChange={(active) => {
                                          setActiveTab(active);
                                        }}
                                        type="card"
                                        destroyOnHidden={true}
                                        items={tabs.map((item) => {
                                          return {
                                            label: item.label,
                                            key: item.key,
                                            children: (
                                              <>
                                                <ChatBubblePrompts
                                                  column={3}
                                                  arrowType="swapright"
                                                  gap={[16, 24]}
                                                  {...embedOptions?.promptsProps}
                                                  onItemClick={(info) =>
                                                    StartChat(
                                                      info.data.title?.toString()
                                                    )
                                                  }
                                                  style={{
                                                    maxWidth: 900,
                                                    margin: "0 auto",
                                                  }}
                                                  block
                                                  type="primary"
                                                  items={(
                                                    embedOptions?.prompts ||
                                                    item.children
                                                  )?.map((hot) => ({
                                                    title:
                                                      hot.name ||
                                                      hot.title ||
                                                      hot.text,
                                                  }))}
                                                />
                                                {/* <ChatBubblePrompts
                                                key={item.label + item.key}
                                                className="znt-welcome-prompts"
                                                onItemClick={(info) =>
                                                  StartChat(
                                                    info.data.title?.toString()
                                                  )
                                                }
                                                style={{
                                                  maxWidth: 400,
                                                  margin: "0 auto",
                                                }}
                                                column={2}
                                                type="primary"
                                                // content={curZnt?.name}
                                                content={initData?.data?.name}
                                                items={item.children?.map(
                                                  (item) => ({
                                                    title: item?.name,
                                                    extra: (
                                                      <SwapRightOutlined />
                                                    ),
                                                  })
                                                )}
                                              ></ChatBubblePrompts> */}
                                              </>
                                            ),
                                          };
                                        })}
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <ChatBubblePrompts
                                      column={3}
                                      arrowType="swapright"
                                      gap={[16, 24]}
                                      {...embedOptions?.promptsProps}
                                      onItemClick={(info) =>
                                        StartChat(info.data.title?.toString())
                                      }
                                      style={{
                                        maxWidth: 900,
                                        margin: "0 auto",
                                      }}
                                      block
                                      type="primary"
                                      items={(
                                        embedOptions?.prompts ||
                                        initData?.data?.hotqas
                                      )?.map((hot) => ({
                                        title:
                                          hot.name || hot.title || hot.text,
                                      }))}
                                    />
                                  </>
                                )
                              }
                            >
                              {embedOptions?.welcome || null}
                            </ChatWelcome>
                          </ChatBoxItem>
                        ) : null
                      ) : (
                        <ChatBoxItem style={{ marginTop: 55 }}>
                          <ChatWelcome
                            icon={initData?.data?.icon}
                            alignCenter={true}
                            // title={curZnt?.name}
                            title={initData?.data?.name}
                            //description={initData?.data?.syssummary}
                            layout="horizontal"
                            content={initData?.data?.summary}
                            size="small"
                            footer={
                              initData?.data?.embeddedpage ? (
                                <>
                                  <iframe
                                    style={{
                                      maxWidth: "400px",
                                      height: "300px",
                                      border: "unset",
                                    }}
                                    src={initData?.data?.embeddedpage}
                                  ></iframe>
                                </>
                              ) : alllength && alllength > 2 ? (
                                <>
                                  <div
                                    style={{
                                      maxWidth: "900px",
                                      maxHeight: "300px",
                                      height: "300px",
                                    }}
                                  >
                                    <Tabs
                                      className="hotTab"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                      }}
                                      activeKey={activeTab}
                                      onChange={(active) => {
                                        setActiveTab(active);
                                      }}
                                      type="card"
                                      destroyOnHidden={true}
                                      items={tabs.map((item) => {
                                        return {
                                          label: item.label,
                                          key: item.key,
                                          children: (
                                            <>
                                              <ChatBubblePrompts
                                                key={item.label + item.key}
                                                className="znt-welcome-prompts"
                                                onItemClick={(info) =>
                                                  StartChat(
                                                    info.data.title?.toString()
                                                  )
                                                }
                                                style={{
                                                  maxWidth: 400,
                                                  margin: "0 auto",
                                                }}
                                                column={2}
                                                type="primary"
                                                // content={curZnt?.name}
                                                content={initData?.data?.name}
                                                items={item.children?.map(
                                                  (item) => ({
                                                    title: item?.name,
                                                    extra: (
                                                      <SwapRightOutlined />
                                                    ),
                                                  })
                                                )}
                                              ></ChatBubblePrompts>
                                            </>
                                          ),
                                        };
                                      })}
                                    />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <ChatBubblePrompts
                                    className="znt-welcome-prompts"
                                    onItemClick={(info) =>
                                      StartChat(info.data.title?.toString())
                                    }
                                    style={{ maxWidth: 400, margin: "0 auto" }}
                                    column={2}
                                    type="primary"
                                    // content={curZnt?.name}
                                    content={initData?.data?.name}
                                    items={initData?.data?.hotqas
                                      // ?.slice(0, 3)
                                      ?.map((item) => ({
                                        title: item?.name,
                                        extra: <SwapRightOutlined />,
                                      }))}
                                  ></ChatBubblePrompts>
                                </>
                              )
                            }
                          ></ChatWelcome>
                        </ChatBoxItem>
                      ),
                    }}
                    onCancel={cancelHandler}
                    onClickGood={(item, index) => {
                      handleEvaluate("good", "", item);
                    }}
                    onClickBad={(item, index) => {
                      setFeedback(item);
                      // handleEvaluate("bad", "", item)
                    }}
                    onClickCopy={(item, index) => {
                      return item.data?.answer;
                    }}
                    receiving={receiving || receivingRef.current}
                    placeholder="请输入你要咨询的问题"
                    mode={mode}
                    welcome={
                      chatBoxProps?.welcome || {
                        alignCenter: true,
                        icon: initData?.data?.sysbiglogo,
                        title: initData?.data?.welcomemsg,
                        content: initData?.data?.syssummary,
                      }
                    }
                    renderAfterSenderBox={
                      window.zdHots
                        ? (mode) => (
                            <>
                              {mode === "welcome" ? (
                                <ChatBoxItem>
                                  <ChatScrollWrapper>
                                    {(window.zdSkills && window.zdSkills.length
                                      ? [...window.zdSkills, ...skillList]
                                      : skillList
                                    ).map((item) => {
                                      return (
                                        <ChatActionButton
                                          key={item.id}
                                          onClick={() => {
                                            console.log(item, "这是技能");
                                            // if (item.type === "zdzx") {
                                            //   setZdzxJump(true);
                                            // } else {
                                            //   setZdzxJump(false);
                                            // }
                                            if (item.type === "zsk") {
                                              setZdKnowledgeOpen(true);
                                              setChooseZsk(true);
                                            } else {
                                              setChooseZsk(false);
                                              setZdKnowledgeOpen(false);
                                            }
                                            if (
                                              item.slots &&
                                              item.slots.length
                                            ) {
                                              let obj = {
                                                slots: [],
                                              };
                                              if (
                                                item.id === "mcp_17_translate"
                                              ) {
                                                item.slots?.map((param) => {
                                                  obj.slots.push({
                                                    name: param?.field,
                                                    label: param?.fieldName,
                                                    required: param?.required,
                                                    defaultValue: param?.value,
                                                    placeholder: param?.example,
                                                    type:
                                                      param.field ===
                                                      "target_language"
                                                        ? "select"
                                                        : param?.type ===
                                                          "string"
                                                        ? "input"
                                                        : param?.type,
                                                    options: (
                                                      param?.enumValues || []
                                                    ).map((jtem) => {
                                                      return {
                                                        label: jtem,
                                                        value: jtem,
                                                      };
                                                    }),
                                                    query: param?.query,
                                                  });
                                                });
                                              } else if (
                                                item.id === "mcp_17_ocr"
                                              ) {
                                                obj.slots.push({});
                                              } else {
                                                item.slots?.map((param) => {
                                                  obj.slots.push({
                                                    name: param?.field,
                                                    label: param?.fieldName,
                                                    required: param?.required,
                                                    defaultValue: param?.value,
                                                    placeholder: param?.example,
                                                    type:
                                                      param?.type === "string"
                                                        ? "input"
                                                        : param?.type,
                                                    options: param?.options,
                                                    query: param?.query,
                                                  });
                                                });
                                              }

                                              if (item.id === "mcp_17_ocr") {
                                                setNewSoltInput(undefined);
                                              } else {
                                                setNewSoltInput({ ...obj });
                                              }

                                              setNewRefresh(Math.random());
                                            } else {
                                              setNewSoltInput(undefined);
                                              setNewRefresh(Math.random());
                                              //   setNewInputSubmit(false);
                                            }
                                            setNewInputSubmit(true);
                                            setNewInputId(item.id);
                                            setSkillName(item.name);
                                          }}
                                        >
                                          {item.name}
                                        </ChatActionButton>
                                      );
                                    })}
                                  </ChatScrollWrapper>
                                </ChatBoxItem>
                              ) : null}
                            </>
                          )
                        : chatBoxProps?.renderAfterSenderBox ||
                          ((mode) => {
                            return mode === "welcome" &&
                              promptsItems?.length ? (
                              <ChatBoxItem>
                                <ChatBubblePromptsCard
                                  size="small"
                                  title="您可以尝试问我以下问题"
                                  column={2}
                                  //@ts-ignore
                                  shape="round"
                                  arrowType="swapright"
                                  type="primary"
                                  extra={
                                    newMode !== "single" ? (
                                      <>
                                        {initData?.data?.hotqas?.length > 6 ? (
                                          <Button
                                            onClick={onReloadHots}
                                            style={{ color: "inherit" }}
                                            type="text"
                                            icon={<ReloadOutlined />}
                                          ></Button>
                                        ) : null}
                                      </>
                                    ) : null
                                  }
                                  onItemClick={(info) =>
                                    StartChat(info.data.title?.toString())
                                  }
                                  items={promptsItems?.slice(0, 6)}
                                />
                              </ChatBoxItem>
                            ) : null;
                          })
                    }
                    prefix={
                      skillsName ? (
                        <>
                          <Button
                            icon={
                              <CloseOutlined
                                onClick={() => {
                                  setSkillName("");
                                  setNewInputId("");
                                  setNewInputSubmit(false);
                                  setChooseZsk(false);
                                  setNewSoltInput(undefined);
                                }}
                                style={{
                                  fontSize: "12px",
                                  color: "",
                                }}
                              />
                            }
                            iconPosition="end"
                            type="text"
                            style={{
                              color: "#1677ff",
                              background: "#0066ff0f",
                              fontSize: "14px",
                              padding: "0 4px",
                              height: "32px",
                            }}
                            size="large"
                          >
                            {skillsName}
                          </Button>
                        </>
                      ) : (
                        ""
                      )
                    }
                    items={items}
                    minRows={
                      window.zdInput ? (isMobile ? 2 : 4) : isMobile ? 2 : 2
                    }
                    maxRows={
                      window.zdInput ? (isMobile ? 5 : 4) : isMobile ? 5 : 8
                    }
                    aiRole={{
                      avatar: {
                        src: <img src={initData?.data?.icon} />,
                      },
                      loadingRender() {
                        return (
                          <span>
                            <ChatLoadingDots />
                          </span>
                        );
                      },
                    }}
                    sendboxTopRender={
                      window.showSkillList && mode == "conversation" ? (
                        <>
                          <ChatScrollWrapper>
                            {skillList && skillList.length > 1
                              ? skillList.map((item) => {
                                  return (
                                    <ChatActionButton
                                      key={item.id}
                                      onClick={() => {
                                        // if (item.slots && item.slots.length) {
                                        //   let obj = {
                                        //     slots: [],
                                        //   };

                                        //   item.slots?.map((param) => {
                                        //     obj.slots.push({
                                        //       name: param?.field,
                                        //       label: param?.fieldName,
                                        //       required: param?.required,
                                        //       defaultValue: param?.value,
                                        //       placeholder: param?.example,
                                        //       type:
                                        //         param?.type === "string"
                                        //           ? "input"
                                        //           : param?.type,
                                        //       options: param?.options,
                                        //       query: param?.query,
                                        //     });
                                        //   });
                                        //   setNewSoltInput({ ...obj });
                                        //   setNewInputSubmit(true);
                                        //   setNewInputId(item.id);
                                        //   setNewRefresh(Math.random());
                                        // } else {
                                        //   setNewSoltInput(undefined);
                                        //   setNewRefresh(Math.random());
                                        //   setNewInputSubmit(false);
                                        //   setNewInputId("");
                                        // }

                                        if (item.slots && item.slots.length) {
                                          let obj = {
                                            slots: [],
                                          };
                                          if (item.id === "mcp_17_translate") {
                                            item.slots?.map((param) => {
                                              obj.slots.push({
                                                name: param?.field,
                                                label: param?.fieldName,
                                                required: param?.required,
                                                defaultValue: param?.value,
                                                placeholder: param?.example,
                                                type:
                                                  param.field ===
                                                  "target_language"
                                                    ? "select"
                                                    : param?.type === "string"
                                                    ? "input"
                                                    : param?.type,
                                                options: (
                                                  param?.enumValues || []
                                                ).map((jtem) => {
                                                  return {
                                                    label: jtem,
                                                    value: jtem,
                                                  };
                                                }),
                                                query: param?.query,
                                              });
                                            });
                                          } else if (item.id === "mcp_17_ocr") {
                                            obj.slots.push({});
                                          } else {
                                            item.slots?.map((param) => {
                                              obj.slots.push({
                                                name: param?.field,
                                                label: param?.fieldName,
                                                required: param?.required,
                                                defaultValue: param?.value,
                                                placeholder: param?.example,
                                                type:
                                                  param?.type === "string"
                                                    ? "input"
                                                    : param?.type,
                                                options: param?.options,
                                                query: param?.query,
                                              });
                                            });
                                          }

                                          if (item.id === "mcp_17_ocr") {
                                            setNewSoltInput(undefined);
                                          } else {
                                            setNewSoltInput({ ...obj });
                                          }

                                          setNewRefresh(Math.random());
                                        } else {
                                          setNewSoltInput(undefined);
                                          setNewRefresh(Math.random());
                                          //   setNewInputSubmit(false);
                                        }
                                        setNewInputSubmit(true);
                                        setNewInputId(item.id);
                                        setSkillName(item.name);
                                      }}
                                    >
                                      {item.name}
                                    </ChatActionButton>
                                  );
                                })
                              : null}
                          </ChatScrollWrapper>
                          {/* {initData?.data?.znttype === 2 ? (
                            12
                          ) : (
                            <>
                              {initData?.data.subjects?.length &&
                              mode == "conversation" ? (
                                <ChatScrollWrapper>
                                  {initData?.data.subjects?.map((item) => {
                                    return (
                                      <ChatActionButton
                                        key={item.id}
                                        onClick={(e) => StartChat(item.name)}
                                      >
                                        {item.name}
                                      </ChatActionButton>
                                    );
                                  })}
                                </ChatScrollWrapper>
                              ) : null}
                            </>
                          )} */}
                        </>
                      ) : (
                        <>
                          {initData?.data.subjects?.length &&
                          mode == "conversation" ? (
                            <ChatScrollWrapper>
                              {initData?.data.subjects?.map((item) => {
                                return (
                                  <ChatActionButton
                                    key={item.id}
                                    onClick={(e) => StartChat(item.name)}
                                  >
                                    {item.name}
                                  </ChatActionButton>
                                );
                              })}
                            </ChatScrollWrapper>
                          ) : null}
                        </>
                      )
                    }
                    ref={chatBoxRef}
                    {...chatBoxProps}
                    onSubmit={(m, p) => {
                      // console.log(m, p, "提交数据")
                      // StartChat(m, p);
                      if (typeof chatBoxProps?.onSubmit === "function") {
                        chatBoxProps.onSubmit(ctx, m, p);
                        // StartChat(m, p);
                      } else {
                        if (zdzxJump) {
                          window.open(
                            `http://10.204.19.136/#?searchType=zh&keyword=${m}`
                          );
                        } else {
                          StartChat(m, p);
                        }
                      }
                    }}
                    onChange={(val) => {
                      setChangeContent(val);
                    }}
                    sendButtonProps={{
                      onClick: (a, b, c, d) => {
                        if (!changeContent) {
                          if (fileList && fileList.length > 0) {
                            if (
                              initData?.data?.enabledimgupload * 1 === 1 &&
                              initData?.data?.enabledfileupload * 1 === 1
                            ) {
                              StartChat("");
                            } else if (
                              initData?.data?.enabledimgupload * 1 ===
                              1
                            ) {
                              StartChat("");
                            } else if (
                              initData?.data?.enabledfileupload * 1 ===
                              1
                            ) {
                              StartChat("");
                            }
                          }
                        }

                        console.log(chatBoxRef);
                        // console.log(a,b,c,d)
                      },
                    }}
                  />
                </>
              )
            ) : activeMenu === "search" ? (
              <iframe
                security=""
                // src="http://bkd.sudytech.cn/sopplus/_web/customized/AIPortalPlus/aisearch/index.html"
                src="http://dreamertest.sudytech.cn/cmai/search/#?keyword=%E8%9E%8D%E5%90%88%E9%97%A8%E6%88%B7&searchType=zh"
                style={{
                  border: "none",
                  outline: "none",
                  height: "100%",
                  width: "100%",
                }}
              ></iframe>
            ) : activeMenu === "brain" ? (
              window.zdSearch ? (
                showActiveMeau ? (
                  <>
                    <>
                      <ChatBox
                        key={"key" + znwdId + newRefresh}
                        slotsInput={newSoltInput}
                        sending={sending || sendingRef.current}
                        allowSpeech={
                          initData?.data?.enabledvinput
                            ? {
                                recording: recording,
                                onRecordingChange: (val) => {
                                  if (val) {
                                    startRecording();
                                    setRecording(val);
                                  } else {
                                    stopRecording();
                                    setRecording(val);
                                  }
                                },
                              }
                            : undefined
                        }
                        header={header}
                        //复制文件
                        onPasteFile={async (event, files) => {
                          if (
                            initData?.data?.enabledimgupload * 1 === 1 ||
                            initData?.data?.enabledfileupload * 1 === 1
                          ) {
                            setFileOpen(true);
                            setTimeout(() => {
                              if (
                                files &&
                                files.length > 0 &&
                                attachmentsRef.current?.upload
                              ) {
                                for (const file of files) {
                                  try {
                                    attachmentsRef.current.upload(file); // 异步处理
                                  } catch (error) {
                                    console.error(
                                      "Error uploading file:",
                                      error
                                    );
                                  }
                                }
                              }
                            }, 5);
                          } else {
                            return "";
                          }
                        }}
                        //文件上传
                        beforeSendActions={
                          <>
                            {initData?.data?.enabledvinput ? (
                              <>
                                {isMobile ? (
                                  <>
                                    {initData?.data?.vinputclientmode * 1 ===
                                      1 ||
                                    initData?.data?.vinputclientmode * 1 ===
                                      3 ? (
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        onClick={() => {
                                          if (recording) {
                                            stopAudio();
                                            setRecording(false);
                                          } else {
                                            startAudio();
                                          }
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          src={
                                            recording
                                              ? AudioLoadingIcon
                                              : AudioIcon
                                          }
                                          alt={
                                            recording ? "结束录音" : "开始录音"
                                          }
                                        />
                                      </div>
                                    ) : undefined}
                                  </>
                                ) : (
                                  <>
                                    {initData?.data?.vinputclientmode * 1 ===
                                      1 ||
                                    initData?.data?.vinputclientmode * 1 ===
                                      2 ? (
                                      <div
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "12px",
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                        onClick={() => {
                                          if (recording) {
                                            stopAudio();
                                            setRecording(false);
                                          } else {
                                            startAudio();
                                          }
                                        }}
                                      >
                                        <img
                                          style={{
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          src={
                                            recording
                                              ? AudioLoadingIcon
                                              : AudioIcon
                                          }
                                          alt={
                                            recording ? "结束录音" : "开始录音"
                                          }
                                        />
                                      </div>
                                    ) : undefined}
                                  </>
                                )}
                              </>
                            ) : null}
                            {initData?.data?.enabledimgupload * 1 === 1 &&
                            initData?.data?.enabledfileupload * 1 === 1 ? (
                              <>
                                <Tooltip
                                  title={
                                    <div>
                                      {`请上传图片或者文件（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式，最多上传${initData?.data?.fileuploadcount}个文件，每个文件大小100MB以内，支持TXT、PDF、 XLSX、 XLS、 DOCX、 CSV、 MD格式）`}
                                    </div>
                                  }
                                >
                                  <span
                                    onClick={() => {
                                      fileAndImgRef?.current?.click();
                                    }}
                                  >
                                    <img
                                      style={{
                                        width: "24px",
                                        height: "24px",
                                        cursor: "pointer",
                                      }}
                                      src={window.zdDisabledFj ? DisFj : Fj}
                                      alt=" "
                                    />
                                    {window.zdDisabledFj ? (
                                      ""
                                    ) : (
                                      <input
                                        type="file"
                                        style={{
                                          display: "none",
                                        }}
                                        ref={fileAndImgRef}
                                        onChange={(a) => {
                                          if (window.zdDisabledFj) {
                                          } else {
                                            setFileOpen(true);
                                            setTimeout(() => {
                                              if (
                                                a.target.files &&
                                                a.target.files.length > 0 &&
                                                attachmentsRef.current?.upload
                                              ) {
                                                for (const file of a.target
                                                  .files) {
                                                  try {
                                                    attachmentsRef.current.upload(
                                                      file
                                                    ); // 异步处理
                                                  } catch (error) {
                                                    console.error(
                                                      "Error uploading file:",
                                                      error
                                                    );
                                                  }
                                                }
                                              }
                                            }, 5);
                                          }
                                        }}
                                      />
                                    )}
                                  </span>
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                {initData?.data?.enabledimgupload * 1 === 1 ? (
                                  <Tooltip
                                    title={`${
                                      initData?.data?.enabledimgupload * 1 ===
                                        1 &&
                                      initData?.data?.enabledfileupload * 1 ===
                                        1
                                        ? "请上传图片或者文件"
                                        : initData?.data?.enabledimgupload *
                                            1 ===
                                          1
                                        ? `请上传图片（最多上传${initData?.data?.imguploadcount}张图片，每张图片大小30M以内，支持JPG, JPEG, PNG格式`
                                        : ""
                                    }`}
                                  >
                                    <span
                                      onClick={() => {
                                        picRef?.current?.click();
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          cursor: "pointer",
                                        }}
                                        src={Fj}
                                        alt=" "
                                      />
                                      <input
                                        type="file"
                                        style={{
                                          display: "none",
                                        }}
                                        ref={picRef}
                                        onChange={(a) => {
                                          setFileOpen(true);
                                          setTimeout(() => {
                                            if (
                                              a.target.files &&
                                              a.target.files.length > 0 &&
                                              attachmentsRef.current?.upload
                                            ) {
                                              for (const file of a.target
                                                .files) {
                                                try {
                                                  attachmentsRef.current.upload(
                                                    file
                                                  ); // 异步处理
                                                } catch (error) {
                                                  console.error(
                                                    "Error uploading file:",
                                                    error
                                                  );
                                                }
                                              }
                                            }
                                          }, 5);
                                        }}
                                      />
                                    </span>{" "}
                                  </Tooltip>
                                ) : undefined}

                                {initData?.data?.enabledfileupload * 1 === 1 ? (
                                  <Tooltip
                                    title={
                                      <div>{`${
                                        initData?.data?.enabledimgupload * 1 ===
                                          1 &&
                                        initData?.data?.enabledfileupload *
                                          1 ===
                                          1
                                          ? "请上传图片或者文件"
                                          : initData?.data?.enabledfileupload *
                                              1 ===
                                            1
                                          ? `请上传文件，最多上传${initData?.data?.fileuploadcount}个文件，，每个文件大小100MB以内，支持TXT、PDF、XLSX、XLS、DOCX、CSV、MD格式`
                                          : ""
                                      }`}</div>
                                    }
                                  >
                                    <span
                                      onClick={() => {
                                        fileRef?.current?.click();
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          cursor: "pointer",
                                        }}
                                        src={Fj}
                                        alt=" "
                                      />
                                      <input
                                        type="file"
                                        style={{
                                          display: "none",
                                        }}
                                        ref={fileRef}
                                        onChange={(a) => {
                                          setFileOpen(true);
                                          setTimeout(() => {
                                            if (
                                              a.target.files &&
                                              a.target.files.length > 0 &&
                                              attachmentsRef.current?.upload
                                            ) {
                                              for (const file of a.target
                                                .files) {
                                                try {
                                                  attachmentsRef.current.upload(
                                                    file
                                                  ); // 异步处理
                                                } catch (error) {
                                                  console.error(
                                                    "Error uploading file:",
                                                    error
                                                  );
                                                }
                                              }
                                            }
                                          }, 5);
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                ) : undefined}
                              </>
                            )}
                          </>
                        }
                        autoLink={true}
                        actions={[
                          //initData?.data?.llmselectenabled  是否开启  1是0否 llmlist 模型列表
                          initData?.data?.llmselectenabled === 1 ? (
                            initData?.data?.llmlist ? (
                              <div className="dropDown" key={"moreModel"}>
                                <Dropdown
                                  trigger={["click"]}
                                  arrow={true}
                                  menu={{
                                    items: moreModel,
                                    selectable: true,
                                    selectedKeys: [selectedModelValue.key],
                                    onClick: ({ key }) => {
                                      const selected = moreModel.find(
                                        (item) => item.key === key
                                      );
                                      if (selected) {
                                        setSelectedModelValue({
                                          key,
                                          label: selected?.label,
                                        });
                                      }
                                    },
                                  }}
                                >
                                  <ChatActionButton key={"moreModelList"}>
                                    {selectedModelValue.label}
                                    <DownOutlined
                                      style={{
                                        fontSize: 12,
                                        color: "rgba(0, 0, 0, 0.45)",
                                        transition: "transform 0.2s",
                                      }}
                                    />
                                  </ChatActionButton>
                                </Dropdown>
                              </div>
                            ) : null
                          ) : null,

                          //initData?.data?.zskList  这是根据后端返回的zskList，做的下拉
                          initData?.data?.zskList &&
                          initData?.data?.zskList.length > 0 ? (
                            initData?.data?.zskList.length > 1 ? (
                              <div key={"dropDown"} className="dropDown">
                                <Dropdown
                                  trigger={["click"]}
                                  arrow={true}
                                  menu={{
                                    items: zskData,
                                    selectable: true,
                                    selectedKeys: [selectedValue.key],
                                    onClick: ({ key }) => {
                                      const selected = zskData.find(
                                        (item) => item.key === key
                                      );
                                      if (selected) {
                                        setSelectedValue({
                                          key,
                                          label: selected?.label,
                                        });
                                      }
                                    },
                                  }}
                                  key={"zskList"}
                                >
                                  <ChatActionButton key={"zskList"}>
                                    {selectedValue.key === "all"
                                      ? selectedValue.label
                                      : selectedValue.label.length > 4
                                      ? selectedValue.label.substring(0, 4) +
                                        "..."
                                      : selectedValue.label}
                                    {}
                                    <DownOutlined
                                      style={{
                                        fontSize: 12,
                                        color: "rgba(0, 0, 0, 0.45)",
                                        transition: "transform 0.2s",
                                      }}
                                    />
                                  </ChatActionButton>
                                </Dropdown>
                              </div>
                            ) : null
                          ) : null,
                          window.showThinking ? (
                            initData?.data?.thinking === false || skillsName ? (
                              <>
                                {chooseZsk ? (
                                  <ChatThinkActionButton
                                    noTitle={false}
                                    key={"deepthink"}
                                    checkable
                                    value={deepthink}
                                    onChange={setDeepthink}
                                  >
                                    {isMobile ? "" : "深度思考"}
                                  </ChatThinkActionButton>
                                ) : null}
                              </>
                            ) : (
                              <>
                                <ChatThinkActionButton
                                  noTitle={false}
                                  key={"deepthink"}
                                  checkable
                                  value={deepthink}
                                  onChange={setDeepthink}
                                >
                                  {isMobile ? "" : "深度思考"}
                                </ChatThinkActionButton>
                                {/* {window.zdZsk ? (
                                  zdKnowledgeName ? (
                                    <>
                                      <ChatActionButton>
                                        <span>{zdKnowledgeName}</span>
                                        <CloseOutlined
                                          onClick={() => {
                                            setZdKnowledgeName("");
                                            setSelectedValue({ key: "" });
                                          }}
                                        />
                                      </ChatActionButton>
                                    </>
                                  ) : (
                                    <ChatActionButton
                                      onClick={() => {
                                        setZdKnowledgeOpen(true);
                                      }}
                                    >
                                      {"请选择知识库"}
                                    </ChatActionButton>
                                  )
                                ) : null} */}
                              </>
                            )
                          ) : null,

                          initData?.data?.portalSearch ? (
                            <ChatPortalActionButton
                              key={"portalsearch"}
                              checkable
                              value={portalSearch}
                              onChange={setPortalSearch}
                            >
                              {isMobile ? "" : "门户搜索"}
                            </ChatPortalActionButton>
                          ) : null,
                          initData?.data?.siteSearch ? (
                            <ChatSiteActionButton
                              key={"sitesearch"}
                              checkable
                              value={siteSearch}
                              onChange={setSiteSearch}
                            >
                              {isMobile ? "" : "站群搜索"}
                            </ChatSiteActionButton>
                          ) : null,
                          initData?.data?.internetSearch ? (
                            <ChatInternetActionButton
                              key={"internetserarch"}
                              checkable
                              value={internetSearch}
                              onChange={setInternetSearch}
                            >
                              {isMobile ? "" : "联网搜索"}
                            </ChatInternetActionButton>
                          ) : null,
                        ]}
                        onClickItemPrompt={({ title }) => {
                          StartChat(title?.toString() ?? "");
                        }}
                        // emboed模式下，输入框前缀图标
                        prefixIcon={
                          embed && embedOptions?.sendBoxPrefixIcon !== false
                            ? embedOptions?.sendBoxPrefixIcon || true
                            : undefined
                        }
                        // renderAfterWelcome={
                        //     <ChatBoxItem gap={24} >

                        //         {/* <ChatPromptsCard title="猜你想问" items={initData?.data?.hotqas?.map(hot => ({ title: hot.name || hot.title || hot.text }))} /> */}
                        //         <div style={{ display: isMobile ? "unset" : "flex", gap: 24 }}>
                        //             <ChatTabsCard className="newQuestion" style={{ flex: "auto", height: "300px" }} items={[
                        //                 {
                        //                     label: "猜你想问",
                        //                     children: <div style={{
                        //                         height: "100%",
                        //                         overflow: "auto"
                        //                     }}>
                        //                         <ChatBubblePrompts column={3} arrowType='swapright' gap={[16, 24]} {...embedOptions?.promptsProps} onItemClick={info => StartChat(info.data.title?.toString())} style={{ maxWidth: 900, margin: '0 auto' }} block type='primary' items={(embedOptions?.prompts || initData?.data?.hotqas)?.map(hot => ({ title: hot.name || hot.title || hot.text }))} />
                        //                     </div>,
                        //                     key: "question"
                        //                 },
                        //                 {
                        //                     label: "测试123",
                        //                     children: <>123</>,
                        //                     key: "tab1"
                        //                 },
                        //                 {
                        //                     label: "测试456",
                        //                     children: <>456</>,
                        //                     key: "tab2"
                        //                 }
                        //             ]} />
                        //             <ChatAgentCube title="精选智能体" slide items={[{
                        //                 name: "图书管助手",
                        //                 description: "任何图书馆相关话题，都可以跟我聊聊"
                        //             }]} />
                        //         </div>

                        //     </ChatBoxItem>

                        // }
                        chatListProps={{
                          // onScrollTop(top) {
                          //   return handleRollLoading()
                          // },
                          emptyHolder: isDefaultAgent ? (
                            embed && !embedOptions?.showDefaultWelcome ? (
                              <ChatBoxItem
                                className={`${embed ? "embedContent" : ""} `}
                              >
                                <ChatWelcome
                                  icon={initData?.data?.icon}
                                  content={initData?.data?.summary}
                                  title={initData?.data?.name}
                                  layout="horizontal"
                                  size="small"
                                  footer={
                                    <ChatBubblePrompts
                                      column={3}
                                      arrowType="swapright"
                                      gap={[16, 24]}
                                      {...embedOptions?.promptsProps}
                                      onItemClick={(info) =>
                                        StartChat(info.data.title?.toString())
                                      }
                                      style={{
                                        maxWidth: 900,
                                        margin: "0 auto",
                                      }}
                                      block
                                      type="primary"
                                      items={(
                                        embedOptions?.prompts ||
                                        initData?.data?.hotqas
                                      )?.map((hot) => ({
                                        title:
                                          hot.name || hot.title || hot.text,
                                      }))}
                                    />
                                  }
                                >
                                  {embedOptions?.welcome || null}
                                </ChatWelcome>
                              </ChatBoxItem>
                            ) : null
                          ) : (
                            <ChatBoxItem style={{ marginTop: 55 }}>
                              <ChatWelcome
                                icon={initData?.data?.icon}
                                alignCenter={true}
                                // title={curZnt?.name}
                                title={initData?.data?.name}
                                //description={initData?.data?.syssummary}
                                layout="horizontal"
                                content={initData?.data?.summary}
                                size="small"
                                footer={
                                  initData?.data?.embeddedpage ? (
                                    <>
                                      <iframe
                                        style={{
                                          maxWidth: "400px",
                                          height: "300px",
                                          border: "unset",
                                        }}
                                        src={initData?.data?.embeddedpage}
                                      ></iframe>
                                    </>
                                  ) : alllength && alllength > 2 ? (
                                    <>
                                      <div
                                        style={{
                                          maxWidth: "900px",
                                          maxHeight: "300px",
                                          height: "300px",
                                        }}
                                      >
                                        <Tabs
                                          className="hotTab"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                          activeKey={activeTab}
                                          onChange={(active) => {
                                            setActiveTab(active);
                                          }}
                                          type="card"
                                          destroyOnHidden={true}
                                          items={tabs.map((item) => {
                                            return {
                                              label: item.label,
                                              key: item.key,
                                              children: (
                                                <>
                                                  <ChatBubblePrompts
                                                    key={item.label + item.key}
                                                    className="znt-welcome-prompts"
                                                    onItemClick={(info) =>
                                                      StartChat(
                                                        info.data.title?.toString()
                                                      )
                                                    }
                                                    style={{
                                                      maxWidth: 400,
                                                      margin: "0 auto",
                                                    }}
                                                    column={2}
                                                    type="primary"
                                                    // content={curZnt?.name}
                                                    content={
                                                      initData?.data?.name
                                                    }
                                                    items={item.children?.map(
                                                      (item) => ({
                                                        title: item?.name,
                                                        extra: (
                                                          <SwapRightOutlined />
                                                        ),
                                                      })
                                                    )}
                                                  ></ChatBubblePrompts>
                                                </>
                                              ),
                                            };
                                          })}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <ChatBubblePrompts
                                        className="znt-welcome-prompts"
                                        onItemClick={(info) =>
                                          StartChat(info.data.title?.toString())
                                        }
                                        style={{
                                          maxWidth: 400,
                                          margin: "0 auto",
                                        }}
                                        column={2}
                                        type="primary"
                                        // content={curZnt?.name}
                                        content={initData?.data?.name}
                                        items={initData?.data?.hotqas
                                          // ?.slice(0, 3)
                                          ?.map((item) => ({
                                            title: item?.name,
                                            extra: <SwapRightOutlined />,
                                          }))}
                                      ></ChatBubblePrompts>
                                    </>
                                  )
                                }
                              ></ChatWelcome>
                            </ChatBoxItem>
                          ),
                        }}
                        onCancel={cancelHandler}
                        onClickGood={(item, index) => {
                          handleEvaluate("good", "", item);
                        }}
                        onClickBad={(item, index) => {
                          setFeedback(item);
                          // handleEvaluate("bad", "", item)
                        }}
                        onClickCopy={(item, index) => {
                          return item.data?.answer;
                        }}
                        receiving={receiving || receivingRef.current}
                        placeholder="请输入你要咨询的问题"
                        mode={mode}
                        welcome={
                          chatBoxProps?.welcome || {
                            alignCenter: true,
                            icon: initData?.data?.sysbiglogo,
                            title: initData?.data?.welcomemsg,
                            content: initData?.data?.syssummary,
                          }
                        }
                        renderAfterSenderBox={
                          window.zdHots ? (
                            <>
                              {mode === "welcome" ? (
                                <ChatBoxItem>
                                  <ChatScrollWrapper>
                                    {(window.zdSkills && window.zdSkills.length
                                      ? [...window.zdSkills, ...skillList]
                                      : skillList
                                    ).map((item) => {
                                      return (
                                        <ChatActionButton
                                          key={item.id}
                                          onClick={() => {
                                            console.log(item, "这是技能");

                                            if (item.type === "zsk") {
                                              setZdKnowledgeOpen(true);
                                              setChooseZsk(true);
                                            } else {
                                              setChooseZsk(false);
                                              setZdKnowledgeOpen(false);
                                            }

                                            if (
                                              item.slots &&
                                              item.slots.length
                                            ) {
                                              let obj = {
                                                slots: [],
                                              };
                                              if (
                                                item.id === "mcp_17_translate"
                                              ) {
                                                item.slots?.map((param) => {
                                                  obj.slots.push({
                                                    name: param?.field,
                                                    label: param?.fieldName,
                                                    required: param?.required,
                                                    defaultValue: param?.value,
                                                    placeholder: param?.example,
                                                    type:
                                                      param.field ===
                                                      "target_language"
                                                        ? "select"
                                                        : param?.type ===
                                                          "string"
                                                        ? "input"
                                                        : param?.type,
                                                    options: (
                                                      param?.enumValues || []
                                                    ).map((jtem) => {
                                                      return {
                                                        label: jtem,
                                                        value: jtem,
                                                      };
                                                    }),
                                                    query: param?.query,
                                                  });
                                                });
                                              } else if (
                                                item.id === "mcp_17_ocr"
                                              ) {
                                                obj.slots.push({});
                                              } else {
                                                item.slots?.map((param) => {
                                                  obj.slots.push({
                                                    name: param?.field,
                                                    label: param?.fieldName,
                                                    required: param?.required,
                                                    defaultValue: param?.value,
                                                    placeholder: param?.example,
                                                    type:
                                                      param?.type === "string"
                                                        ? "input"
                                                        : param?.type,
                                                    options: param?.options,
                                                    query: param?.query,
                                                  });
                                                });
                                              }
                                              if (item.id === "mcp_17_ocr") {
                                                setNewSoltInput(undefined);
                                              } else {
                                                setNewSoltInput({ ...obj });
                                              }

                                              setNewRefresh(Math.random());
                                            } else {
                                              setNewSoltInput(undefined);
                                              setNewRefresh(Math.random());
                                              //   setNewInputSubmit(false);
                                            }
                                            setNewInputSubmit(true);
                                            setNewInputId(item.id);
                                            setSkillName(item.name);
                                          }}
                                        >
                                          {item.name}
                                        </ChatActionButton>
                                      );
                                    })}
                                  </ChatScrollWrapper>
                                </ChatBoxItem>
                              ) : null}
                            </>
                          ) : (
                            chatBoxProps?.renderAfterSenderBox ||
                            ((mode) => {
                              return mode === "welcome" &&
                                promptsItems?.length ? (
                                <ChatBoxItem>
                                  <ChatBubblePromptsCard
                                    size="small"
                                    title="您可以尝试问我以下问题"
                                    column={2}
                                    //@ts-ignore
                                    shape="round"
                                    arrowType="swapright"
                                    type="primary"
                                    extra={
                                      newMode !== "single" ? (
                                        <>
                                          {initData?.data?.hotqas?.length >
                                          6 ? (
                                            <Button
                                              onClick={onReloadHots}
                                              style={{ color: "inherit" }}
                                              type="text"
                                              icon={<ReloadOutlined />}
                                            ></Button>
                                          ) : null}
                                        </>
                                      ) : null
                                    }
                                    onItemClick={(info) =>
                                      StartChat(info.data.title?.toString())
                                    }
                                    items={promptsItems?.slice(0, 6)}
                                  />
                                </ChatBoxItem>
                              ) : null;
                            })
                          )
                        }
                        items={items}
                        minRows={
                          window.zdInput ? (isMobile ? 2 : 4) : isMobile ? 2 : 2
                        }
                        maxRows={
                          window.zdInput ? (isMobile ? 5 : 4) : isMobile ? 5 : 8
                        }
                        aiRole={{
                          avatar: {
                            src: <img src={initData?.data?.icon} />,
                          },
                          loadingRender() {
                            return (
                              <span>
                                <ChatLoadingDots />
                              </span>
                            );
                          },
                        }}
                        prefix={
                          skillsName ? (
                            <>
                              <Button
                                icon={
                                  <CloseOutlined
                                    onClick={() => {
                                      setSkillName("");
                                      setNewInputId("");
                                      setNewInputSubmit(false);
                                      setChooseZsk(false);
                                      setNewSoltInput(undefined);
                                    }}
                                    style={{
                                      fontSize: "12px",
                                      color: "",
                                    }}
                                  />
                                }
                                iconPosition="end"
                                type="text"
                                style={{
                                  color: "#1677ff",
                                  background: "#0066ff0f",
                                }}
                                size="large"
                              >
                                {skillsName}
                              </Button>
                            </>
                          ) : (
                            ""
                          )
                        }
                        sendboxTopRender={
                          window.showSkillList && mode === "conversation" ? (
                            <ChatScrollWrapper>
                              {skillList && skillList.length > 1
                                ? skillList.map((item) => {
                                    return (
                                      <ChatActionButton
                                        key={item.id}
                                        onClick={() => {
                                          if (item.slots && item.slots.length) {
                                            let obj = {
                                              slots: [],
                                            };
                                            if (
                                              item.id === "mcp_17_translate"
                                            ) {
                                              item.slots?.map((param) => {
                                                obj.slots.push({
                                                  name: param?.field,
                                                  label: param?.fieldName,
                                                  required: param?.required,
                                                  defaultValue: param?.value,
                                                  placeholder: param?.example,
                                                  type:
                                                    param.field ===
                                                    "target_language"
                                                      ? "select"
                                                      : param?.type === "string"
                                                      ? "input"
                                                      : param?.type,
                                                  options: (
                                                    param?.enumValues || []
                                                  ).map((jtem) => {
                                                    return {
                                                      label: jtem,
                                                      value: jtem,
                                                    };
                                                  }),
                                                  query: param?.query,
                                                });
                                              });
                                            } else if (
                                              item.id === "mcp_17_ocr"
                                            ) {
                                              obj.slots.push({});
                                            } else {
                                              item.slots?.map((param) => {
                                                obj.slots.push({
                                                  name: param?.field,
                                                  label: param?.fieldName,
                                                  required: param?.required,
                                                  defaultValue: param?.value,
                                                  placeholder: param?.example,
                                                  type:
                                                    param?.type === "string"
                                                      ? "input"
                                                      : param?.type,
                                                  options: param?.options,
                                                  query: param?.query,
                                                });
                                              });
                                            }

                                            if (item.id === "mcp_17_ocr") {
                                              setNewSoltInput(undefined);
                                            } else {
                                              setNewSoltInput({ ...obj });
                                            }

                                            setNewRefresh(Math.random());
                                          } else {
                                            setNewSoltInput(undefined);
                                            setNewRefresh(Math.random());
                                            //   setNewInputSubmit(false);
                                          }
                                          setNewInputSubmit(true);
                                          setNewInputId(item.id);
                                          setSkillName(item.name);
                                        }}
                                      >
                                        {item.name}
                                      </ChatActionButton>
                                    );
                                  })
                                : null}
                            </ChatScrollWrapper>
                          ) : (
                            // <>
                            //   {initData?.data?.znttype === 2 ? (
                            //    12
                            //   ) : (
                            //     <>
                            //       {initData?.data.subjects?.length &&
                            //       mode == "conversation" ? (
                            //         <ChatScrollWrapper>
                            //           {initData?.data.subjects?.map((item) => {
                            //             return (
                            //               <ChatActionButton
                            //                 key={item.id}
                            //                 onClick={(e) =>
                            //                   StartChat(item.name)
                            //                 }
                            //               >
                            //                 {item.name}
                            //               </ChatActionButton>
                            //             );
                            //           })}
                            //         </ChatScrollWrapper>
                            //       ) : null}
                            //     </>
                            //   )}
                            // </>
                            <>
                              {initData?.data.subjects?.length &&
                              mode == "conversation" ? (
                                <ChatScrollWrapper>
                                  {initData?.data.subjects?.map((item) => {
                                    return (
                                      <ChatActionButton
                                        key={item.id}
                                        onClick={(e) => StartChat(item.name)}
                                      >
                                        {item.name}
                                      </ChatActionButton>
                                    );
                                  })}
                                </ChatScrollWrapper>
                              ) : null}
                            </>
                          )
                        }
                        ref={chatBoxRef}
                        {...chatBoxProps}
                        onSubmit={(m, p) => {
                          // console.log(m, p, "提交数据")
                          // StartChat(m, p);
                          if (typeof chatBoxProps?.onSubmit === "function") {
                            chatBoxProps.onSubmit(ctx, m, p);
                            // StartChat(m, p);
                          } else {
                            if (zdzxJump) {
                              window.open(
                                `http://10.204.19.136/#?searchType=zh&keyword=${m}`
                              );
                            } else {
                              StartChat(m, p);
                            }
                          }
                        }}
                        canSend={
                          fileList && fileList.length > 0 ? true : undefined
                        }
                        onChange={(val) => {
                          setChangeContent(val);
                        }}
                        sendButtonProps={{
                          onClick: (a, b, c, d) => {
                            if (!changeContent) {
                              if (fileList && fileList.length > 0) {
                                if (
                                  initData?.data?.enabledimgupload * 1 === 1 &&
                                  initData?.data?.enabledfileupload * 1 === 1
                                ) {
                                  StartChat(
                                    initData?.data?.fileuploadmsg || ""
                                  );
                                } else if (
                                  initData?.data?.enabledimgupload * 1 ===
                                  1
                                ) {
                                  StartChat(initData?.data?.imguploadmsg || "");
                                } else if (
                                  initData?.data?.enabledfileupload * 1 ===
                                  1
                                ) {
                                  StartChat(
                                    initData?.data?.fileuploadmsg || ""
                                  );
                                }
                              }
                            }

                            console.log(chatBoxRef);
                            // console.log(a,b,c,d)
                          },
                        }}
                      />
                    </>
                  </>
                ) : (
                  <ZdSearch
                    onClick={(key) => {
                      if (key?.outerznt) {
                        if (key?.outOpen * 1 === 1) {
                          window.open(key?.outerurl);
                        } else if (key?.outOpen * 1 === 2) {
                          setActiveMenu("innerIframe");
                          setInnerUrl(key?.outerurl);
                        }
                      } else {
                        swtichZnt(key?.key ?? "");
                      }

                      //navigate(`chat?znwdId=${key?.key ?? ""}`)
                    }}
                  />
                )
              ) : (
                <Search
                  onClick={(key) => {
                    if (key?.outerznt) {
                      window.open(key?.outerurl);
                    } else {
                      swtichZnt(key?.key ?? "");
                    }

                    //navigate(`chat?znwdId=${key?.key ?? ""}`)
                  }}
                ></Search>
              )
            ) : activeMenu === "mxfw" ? (
              <Mxgc activeTab={mxfwActiveTab} mxglActivetab={mxglActivetab} />
            ) : activeMenu === "zskzx" ? (
              <Zskzx />
            ) : activeMenu === "zntkfpt" ? (
              <Zntkfpt />
            ) : activeMenu === "cjzx" ? (
              <Cjzx />
            ) : activeMenu === "slfw" ? (
              <Slfw />
            ) : activeMenu === "innerIframe" ? (
              <iframe
                src={innerUrl}
                style={{
                  border: "none",
                  outline: "none",
                  height: "100%",
                  width: "100%",
                }}
                security=""
              />
            ) : null}
          </ChatLayout>
          {recording &&
            isMobile &&
            window.isFullTime &&
            window.isMobileAudio &&
            createPortal(
              <>
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    zIndex: 9998,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                />
                <div
                  style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "240px",
                    backgroundColor: "#fff",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    boxShadow: "0 -4px 12px rgba(0,0,0,0.1)",
                    padding: "24px 20px 40px",
                    transition: "all 0.3s ease-in-out",
                  }}
                >
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      color: "#333",
                      marginBottom: "40px",
                    }}
                  >
                    正在录音...
                  </div>
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      height: "40px",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                      <div
                        key={i}
                        style={{
                          width: "4px",
                          height: "10px",
                          background: "#1890ff",
                          borderRadius: "2px",
                          animation: "wave 1.2s infinite ease-in-out",
                          animationDelay: `${i * 0.1}s`,
                        }}
                      />
                    ))}
                    <style>{`
                    @keyframes wave {
                      0%, 100% { height: 10px; opacity: 0.5; }
                      50% { height: 32px; opacity: 1; }
                    }
                  `}</style>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-around",
                      alignItems: "center",
                      marginTop: "auto",
                    }}
                  >
                    <div
                      onClick={cancelRecording}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          width: "72px",
                          height: "72px",
                          borderRadius: "50%",
                          background: "#f5f5f5",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                          marginBottom: "8px",
                          border: "1px solid #eee",
                        }}
                      >
                        <CloseOutlined
                          style={{ fontSize: "32px", color: "#666" }}
                        />
                      </div>
                      <span style={{ fontSize: "16px", color: "#666" }}>
                        取消
                      </span>
                    </div>
                    <div
                      onClick={stopAudio}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          width: "72px",
                          height: "72px",
                          borderRadius: "50%",
                          background: "#1890ff",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 4px 12px rgba(24,144,255,0.4)",
                          marginBottom: "8px",
                        }}
                      >
                        <CheckOutlined
                          style={{ fontSize: "32px", color: "#fff" }}
                        />
                      </div>
                      <span style={{ fontSize: "16px", color: "#333" }}>
                        发送
                      </span>
                    </div>
                  </div>
                </div>
              </>,
              document.body
            )}

          <ChatFeedBack
            open={feedback ? true : false}
            onCancel={() => setFeedback(null)}
            onSubmit={(text) => {
              setFeedback(null);
              return handleEvaluate("bad", text, feedback);
            }}
          />
          {renameOpen ? (
            <Modal
              destroyOnHidden={true}
              key={renameData?.key}
              title={
                <Typography.Title style={{ fontSize: 16 }}>
                  {"重命名对话"}
                </Typography.Title>
              }
              open={renameOpen}
              onCancel={() => {
                setRenameData({});
                setReNameOpen(false);
              }}
              onOk={() => {
                renameForm
                  .validateFields()
                  .then((values) => {
                    if (values.name) {
                      runGetUpdateChat({
                        title: values.name,
                        chatId: renameData?.key,
                      });
                    }
                  })
                  .catch(() => {});
              }}
            >
              <Form
                key={renameData?.key}
                form={renameForm}
                initialValues={{ name: renameData?.name }}
              >
                <Form.Item
                  rules={[{ required: true, message: "对话名称不能为空" }]}
                  required
                  name={"name"}
                >
                  <Input key={renameData}></Input>
                </Form.Item>
              </Form>
            </Modal>
          ) : null}
          {tokenOpen ? (
            <Drawer open={tokenOpen} placement="bottom"></Drawer>
          ) : null}
          {zdKnowledgeOpen ? (
            <>
              <Drawer
                title="知识库"
                open={zdKnowledgeOpen}
                destroyOnHidden
                width={"65%"}
                onClose={() => {
                  setZdKnowledgeOpen(false);
                  setZdKnowledgeName("");
                  setSkillName("");
                  setChooseZsk(false);
                }}
                footer={
                  <>
                    <Space>
                      <Button
                        onClick={() => {
                          setZdKnowledgeOpen(false);
                          setZdKnowledgeName("");
                          setSkillName("");
                          setChooseZsk(false);
                        }}
                      >
                        关闭
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          console.log(zdKnowledgeRef);
                          const data = zdKnowledgeRef?.current?.getValue();
                          setSelectedValue({
                            key: data?.zskId,
                          });
                          setZdKnowledgeName(data?.zskName);
                          setZdKnowledgeOpen(false);
                          setSkillName(data?.zskName);
                        }}
                      >
                        确定
                      </Button>
                    </Space>
                  </>
                }
              >
                <ZdKnowledge ref={zdKnowledgeRef} />
              </Drawer>
            </>
          ) : null}
        </Spin>
      </ChatPortalLayout>
    </ChatContext.Provider>
  );
}
